<template>
  <div class="animated fadeIn">
    <!-- Chi tiết văn bản -->
    <b-row>
      <b-col md="5" class="pr-0 pl-0">
        <el-tabs
          type="border-card"
          v-model="activeCard"
          @tab-click="handleClick"
        >
          <!-- Start Tab ChiTietVanBan -->
          <el-tab-pane name="ChiTietVanBan">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon isax-document-text-1 mr-2"></i>
                <span>Chi tiết văn bản</span>
              </div>
            </span>
            <!-- Start Tab Body -->
            <el-form
              ref="myForm"
              :model="mData.dataForm"
              :rules="mData.validForm"
              @submit.native.prevent
              label-width="126px"
              class="pt-3 pb-3"
            >
              <b-col md="12" class="">
                <div>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Tiêu đề:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong :title="mData.dataForm.name">{{
                        mData.dataForm.name
                      }}</strong></b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col md="4" class="pt-1">
                      <p>Trích yếu nội dung văn bản:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow-3"
                      ><strong :title="mData.dataForm.description">{{
                        mData.dataForm.description
                      }}</strong></b-col
                    >
                  </b-row>
                  <el-divider></el-divider>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Mã văn bản:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong :title="mData.dataForm.code">{{
                        mData.dataForm.code
                      }}</strong></b-col
                    >
                  </b-row>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Ngành:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong :title="mData.dataForm.business_name">{{
                        mData.dataForm.business_name
                      }}</strong></b-col
                    >
                  </b-row>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Loại văn bản:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong :title="mData.dataForm.document_category_name">{{
                        mData.dataForm.document_category_name
                      }}</strong></b-col
                    >
                  </b-row>
                  <b-row class="mb-2">
                    <b-col md="4" style="padding-top: 10px">
                      <p>Số ký kiệu:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow">
                      <div
                        v-if="!isEditBookNumber"
                        class="d-flex align-items-center"
                      >
                        <strong :title="mData.dataForm.book_number">{{
                          mData.dataForm.book_number
                        }}</strong>
                        <i
                          v-if="
                            mData.dataForm.status != 'PUBLISHED' &&
                            (mData.dataForm.author_id == mData.currentUser.id ||
                              (docType == 'DOC_ISSUE' &&
                                listRole &&
                                listRole.includes('VT')))
                          "
                          class="icon icon-update-booknumber icon24-VB_ChoKyDuyet ml-2"
                          @click="fn_clickEditBookNumber()"
                          title="Cập nhật"
                        ></i>
                      </div>

                      <div v-else class="d-flex">
                        <el-form
                          ref="formEditBookNumber"
                          :model="mData.dataFormEditBookNumber"
                          :rules="mData.validFormEditBookNumber"
                          @submit.native.prevent
                          style="border: 0; width: 100%"
                        >
                          <el-form-item
                            label=""
                            prop="newBookNumber"
                            style="margin-bottom: 17px"
                          >
                            <el-input
                              type="text"
                              v-model.trim="
                                mData.dataFormEditBookNumber.newBookNumber
                              "
                              @change="
                                () => {
                                  mData.dataFormEditBookNumber.newBookNumber =
                                    mData.dataFormEditBookNumber.newBookNumber.toUpperCase();
                                }
                              "
                              placeholder="(X)/QĐ-(Y)-(Z)"
                              maxlength="255"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                        <div class="mt-1">
                          <i
                            class="icon fal fa-check c-green ml-2 mr-2"
                            @click="fn_updateBookNumber()"
                            title="Cập nhật"
                          ></i>
                          <i
                            class="icon el-icon-close c-red"
                            @click="fn_cancelBookNumber()"
                            title="Hủy"
                          ></i>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Độ khẩn:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong :title="mData.dataForm.urgency_id">{{
                        mData.dataForm.urgency_id
                      }}</strong></b-col
                    >
                  </b-row>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Độ mật:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow">
                      <strong
                        :title="mData.dataForm.secret_id"
                        v-if="
                          mData.dataForm.secret_id === 'Bình thường' ||
                          mData.dataForm.secret_id === 'Không xác định'
                        "
                        >{{ mData.dataForm.secret_id }}</strong
                      >
                      <div
                        v-if="
                          mData.dataForm.secret_id &&
                          mData.dataForm.secret_id !== 'Bình thường' &&
                          mData.dataForm.secret_id !== 'Không xác định'
                        "
                        class="secret text-center"
                      >
                        {{ mData.dataForm.secret_id }}
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Hình thức:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong :title="mData.dataForm.type_name">{{
                        mData.dataForm.type_name
                      }}</strong></b-col
                    >
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="4" class="pt-1">
                      <p>Trạng thái:</p>
                    </b-col>
                    <b-col
                      md="8"
                      class="text-overflow d-flex"
                      v-if="!loadingStatus"
                    >
                      <strong
                        v-if="mData.dataForm.status == 'REJECT_FOR_SIGN'"
                        :title="mData.dataForm.status"
                        class="mr-2"
                        :class="
                          mData.dataForm.status == 'REJECT_FOR_SIGN'
                            ? 'c-red'
                            : ''
                        "
                        >{{ mData.dataForm.status_name }}</strong
                      >
                      <div
                        v-if="
                          mData.dataForm.status == 'REJECTED' ||
                          (isRejectTempSigned && docType == 'DOC_SIGN_TEMP') ||
                          $route.query.statusFilter == 'DOC_DRAFF_REJECTED'
                        "
                        class="block-red mr-2"
                      >
                        {{ fn_convertDocRejectStatus() }}
                      </div>
                      <div
                        v-if="fn_conditionDisplaySignedOrPublished()"
                        class="block-turquoise mr-2"
                      >
                        <i
                          class="icon el-icon-check"
                          v-if="fn_conditionDisplayCheckIcon()"
                        ></i>
                        {{ fn_convertDocStatusIsSignedOrPublished() }}
                      </div>
                      <!-- Start Block KyNhay -->
                      <div
                        v-if="
                          docType != 'DOC_SIGN_TEMP' &&
                          isWaitingForSignTemp &&
                          mData.dataForm.status == 'WAITING_FOR_SIGN'
                        "
                        class="block-yellow"
                      >
                        Đang yêu cầu ký nháy
                      </div>
                      <!-- End Block KyNhay -->

                      <!-- Start Status for other company Block -->
                      <div
                        v-if="fn_conditionDisplayBlockOtherCompanySigned()"
                        class="block-turquoise"
                      >
                        <i class="icon el-icon-check"></i>
                        Đối tác đã ký duyệt
                      </div>
                      <div
                        v-if="fn_conditionDisplayBlockOtherCompanyRejected()"
                        class="block-red"
                      >
                        Đối tác đã từ chối
                      </div>
                      <!-- End Status for other company Block -->
                    </b-col>
                  </b-row>
                  <el-divider></el-divider>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Người tạo:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong :title="mData.dataForm.creator_name">{{
                        mData.dataForm.creator_name
                      }}</strong></b-col
                    >
                  </b-row>
                  <div v-if="docType != 'DOC_SIGN_TEMP'" class="mb-2">
                    <b-row
                      v-for="(signer, i) in mData.dataForm.signers"
                      :key="i"
                    >
                      <b-col md="4" class="pt-1">
                        <p v-if="i == 0">Người ký:</p>
                      </b-col>
                      <b-col
                        md="8"
                        class="text-overflow"
                        :class="
                          i > 0 &&
                          mData.dataForm.signers &&
                          i != mData.dataForm.signers.length - 1
                            ? 'mb-2'
                            : ''
                        "
                        ><strong
                          :title="`${signer.user_name} ${
                            signer.position_name
                              ? '(' + signer.position_name + ')'
                              : ''
                          }${
                            fn_getSignerStatusName(signer.status)
                              ? ' - ' + fn_getSignerStatusName(signer.status)
                              : ''
                          }`"
                        >
                          {{
                            `${signer.user_name} ${
                              signer.position_name
                                ? "(" + signer.position_name + ")"
                                : ""
                            }`
                          }}
                        </strong>
                        <span
                          v-if="fn_getSignerStatusName(signer.status)"
                          class="signer-status"
                          :class="`signer-status--${signer.status.toLowerCase()}`"
                        >
                          {{ fn_getSignerStatusName(signer.status) }}
                        </span></b-col
                      >
                    </b-row>
                  </div>
                  <b-row v-if="mData.dataForm.status == 'PUBLISHED'">
                    <b-col md="4" class="pt-1">
                      <p>Nơi ban hành:</p>
                    </b-col>
                    <b-col
                      md="8"
                      class="text-overflow"
                      v-if="mData.dataForm.publish.department_id"
                    >
                      <strong v-if="!loadDepartment">
                        {{
                          getNameDepartment(
                            mData.dataForm.publish.department_id
                          )
                        }}
                      </strong>
                    </b-col>
                  </b-row>
                  <el-divider></el-divider>
                  <b-row class="mb-2">
                    <b-col md="4" class="pt-1">
                      <p>Ngày tạo:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong
                        :title="fn_formatDate(mData.dataForm.created_at)"
                        >{{ fn_formatDate(mData.dataForm.created_at) }}</strong
                      ></b-col
                    >
                  </b-row>
                  <b-row
                    v-if="
                      mData.dataForm.publish.publish_at &&
                      docType != 'DOC_SIGN_TEMP'
                    "
                    class="mb-2"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Ngày ban hành:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong
                        :title="
                          fn_formatDate(mData.dataForm.publish.publish_at)
                        "
                        >{{
                          fn_formatDate(mData.dataForm.publish.publish_at)
                        }}</strong
                      ></b-col
                    >
                  </b-row>
                  <b-row
                    v-if="
                      mData.dataForm.status == 'PUBLISHED' &&
                      mData.dataForm.effected_date &&
                      mData.dataForm.effected_date.start_effected_at
                    "
                    class="mb-2"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Ngày hiệu lực:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong
                        :title="
                          fn_formatDate(
                            mData.dataForm.effected_date.start_effected_at
                          )
                        "
                        >{{
                          fn_formatDate(
                            mData.dataForm.effected_date.start_effected_at
                          )
                        }}</strong
                      ></b-col
                    >
                  </b-row>
                  <b-row
                    v-if="
                      mData.dataForm.status == 'PUBLISHED' &&
                      mData.dataForm.effected_date &&
                      mData.dataForm.effected_date.end_effected_at
                    "
                    class="mb-2"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Ngày hết hiệu lực:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow"
                      ><strong
                        :title="
                          fn_formatDate(
                            mData.dataForm.effected_date.end_effected_at
                          )
                        "
                        >{{
                          fn_formatDate(
                            mData.dataForm.effected_date.end_effected_at
                          )
                        }}</strong
                      ></b-col
                    >
                  </b-row>
                  <b-row v-if="!isHideDeadline">
                    <b-col md="4">
                      <p>Thời hạn xử lý:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow">
                      <i
                        class="icon isax-clock mr-2"
                        style="font-size: inherit"
                      ></i>
                      <strong :title="fn_showDeadlineManipulately()">{{
                        fn_showDeadlineManipulately()
                      }}</strong></b-col
                    >
                  </b-row>
                  <el-divider></el-divider>
                  <b-row>
                    <b-col md="4" class="pt-1">
                      <p class="mt-2">Đính kèm:</p>
                    </b-col>
                    <b-col md="8" class="text-overflow">
                      <el-upload
                        v-if="
                          mData.fileUploadOption.fileOther.fileList.length > 0
                        "
                        ref="upload"
                        :auto-upload="false"
                        list-type="text"
                        action
                        :on-preview="previewFile"
                        :file-list="mData.fileUploadOption.fileOther.fileList"
                        :limit="mData.fileUploadOption.fileOther.limit"
                        disabled
                        multiple
                      >
                      </el-upload>
                      <p class="bold mt-2" v-else>Không có file đính kèm</p>
                    </b-col>
                  </b-row>
                  <el-divider
                    v-if="mData.moreInformationForm.identity"
                  ></el-divider>
                  <p v-if="mData.moreInformationForm.identity">
                    <b>Thông tin lưu trữ</b>
                  </p>
                  <b-row class="mb-2">
                    <b-col
                      md="4"
                      class="pt-1"
                      v-if="mData.moreInformationForm.identity"
                    >
                      <p>Mã định danh cơ quan:</p>
                    </b-col>
                    <b-col
                      md="8"
                      class=""
                      v-if="mData.moreInformationForm.identity"
                    >
                      <strong :title="mData.moreInformationForm.identity">
                        {{ mData.moreInformationForm.identity }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.history_archive_code"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Mã cơ quan lưu trữ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.history_archive_code"
                      >
                        {{ mData.moreInformationForm.history_archive_code }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.history_archive"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Cơ quan lưu trữ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.history_archive"
                      >
                        {{ mData.moreInformationForm.history_archive }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.table_of_contents"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Mục lục:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.table_of_contents"
                      >
                        {{ mData.moreInformationForm.table_of_contents }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.doc_year_formation"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Năm hình thành hồ sơ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.doc_year_formation"
                      >
                        {{ mData.moreInformationForm.doc_year_formation }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.file_classification"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Phân loại hồ sơ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.file_classification"
                      >
                        {{ mData.moreInformationForm.file_classification }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.doc_file_count"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Tổng số văn bản trong hồ sơ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.doc_file_count">
                        {{ mData.moreInformationForm.doc_file_count }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.folder_save"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Folder lưu trữ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.folder_save">
                        {{ mData.moreInformationForm.folder_save }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.location_save"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Vị trí lưu:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.location_save">
                        {{ mData.moreInformationForm.location_save }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="mData.moreInformationForm.shelf">
                    <b-col md="4" class="pt-1">
                      <p>Giá/kệ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.shelf">
                        {{ mData.moreInformationForm.shelf }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="mData.moreInformationForm.bag">
                    <b-col md="4" class="pt-1">
                      <p>Hộp/cặp:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.bag">
                        {{ mData.moreInformationForm.bag }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="mData.moreInformationForm.storage">
                    <b-col md="4" class="pt-1">
                      <p>Kho lưu trữ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.storage">
                        {{ mData.moreInformationForm.storage }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.depository_unit"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Đơn vị nộp lưu:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.depository_unit"
                      >
                        {{ mData.moreInformationForm.depository_unit }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.info_symbol"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Ký hiệu thông tin:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.info_symbol">
                        {{ mData.moreInformationForm.info_symbol }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="mData.moreInformationForm.barcode">
                    <b-col md="4" class="pt-1">
                      <p>Mã barcode:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.barcode">
                        {{ mData.moreInformationForm.barcode }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.font_family"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Phông:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.font_family">
                        {{ mData.moreInformationForm.font_family }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="mData.moreInformationForm.language">
                    <b-col md="4" class="pt-1">
                      <p>Ngôn ngữ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.language">
                        {{ mData.moreInformationForm.language }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.physical_status"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Tình trạng vật lý:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.physical_status"
                      >
                        {{ mData.moreInformationForm.physical_status }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.number_of_pages"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Số lượng trang:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.number_of_pages"
                      >
                        {{ mData.moreInformationForm.number_of_pages }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.number_of_sheets"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Số lượng tờ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.number_of_sheets"
                      >
                        {{ mData.moreInformationForm.number_of_sheets }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.year_save"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Năm lưu trữ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.year_save">
                        {{ mData.moreInformationForm.year_save }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.number_of_year_save"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Số năm lưu trữ:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="mData.moreInformationForm.number_of_year_save"
                      >
                        {{ mData.moreInformationForm.number_of_year_save }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.start_time"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Thời gian bắt đầu:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="
                          MethodService.formatDate(
                            mData.moreInformationForm.start_time,
                            'date'
                          )
                        "
                      >
                        {{
                          MethodService.formatDate(
                            mData.moreInformationForm.start_time,
                            "date"
                          )
                        }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="mData.moreInformationForm.end_time">
                    <b-col md="4" class="pt-1">
                      <p>Thời gian kết thúc:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="
                          MethodService.formatDate(
                            mData.moreInformationForm.end_time,
                            'date'
                          )
                        "
                      >
                        {{
                          MethodService.formatDate(
                            mData.moreInformationForm.end_time,
                            "date"
                          )
                        }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.shelf_life_time"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Thời hạn bảo quản:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong
                        :title="
                          MethodService.formatDate(
                            mData.moreInformationForm.shelf_life_time,
                            'date'
                          )
                        "
                      >
                        {{
                          MethodService.formatDate(
                            mData.moreInformationForm.shelf_life_time,
                            "date"
                          )
                        }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.usage_mode"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Chế độ sử dụng:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.usage_mode">
                        {{ mData.moreInformationForm.usage_mode }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-2"
                    v-if="mData.moreInformationForm.key_words"
                  >
                    <b-col md="4" class="pt-1">
                      <p>Từ khóa:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.key_words">
                        {{ mData.moreInformationForm.key_words }}
                      </strong>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="mData.moreInformationForm.note">
                    <b-col md="4" class="pt-1">
                      <p>Chú giải:</p>
                    </b-col>
                    <b-col md="8" class="">
                      <strong :title="mData.moreInformationForm.note">
                        {{ mData.moreInformationForm.note }}
                      </strong>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </el-form>
            <!-- Start Tab Body -->
          </el-tab-pane>
          <!-- End Tab ChiTietVanBan -->
          <!-- Start Tab LichSuXuLy -->
          <el-tab-pane name="LichSuXuLy">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon isax-clock mr-2"></i>
                <span>Lịch sử xử lý</span>
              </div>
            </span>
            <el-empty
              v-if="listDocHistory.length == 0"
              description="Lịch sử xử lý văn bản trống"
              style="height: 100%; border: 1px solid"
            ></el-empty>
            <div v-else class="timeline">
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  v-for="(activity, index) in listDocHistory"
                  :key="index"
                  color="#000"
                  size="normal"
                >
                  <div v-for="(activityDetail, i) in activity" :key="i">
                    <div
                      v-if="
                        activityDetail.type !== 'REQUEST_DRAFF_SIGN' ||
                        activityDetail.type == 'REQUEST_DRAFF_SIGN'
                      "
                    >
                      <div class="d-flex align-items-center mb-2">
                        <div
                          v-if="i == 0"
                          :class="
                            fn_checkClassForActivitiesBlock(activityDetail)
                          "
                        >
                          {{ fn_convertActivityName(activityDetail.type) }}
                          {{
                            activity.length > 1 ? `(${activity.length})` : ""
                          }}
                        </div>
                        <span v-if="i == 0" class="ml-2"
                          >vào lúc:
                          <strong>{{
                            fn_formatDatetime(activityDetail.time_at)
                          }}</strong></span
                        >
                      </div>
                      <div class="d-flex">
                        <el-avatar
                          :src="fn_getSourceActivitiesAvt(activityDetail)"
                          class="mr-2"
                        ></el-avatar>
                        <div>
                          <p
                            :class="{
                              'bold mb-1 text-overflow-280': true,
                              'c-red': fn_fillClassExecutor(activityDetail),
                            }"
                            style="font-weight: bolder"
                          >
                            {{ fn_convertExecutorName(activityDetail) }}
                          </p>
                          <span>
                            <span
                              class="span__block-overflow"
                              style="margin-block: -5px"
                            >
                              {{ fn_convertExecutorNo(activityDetail) }}
                            </span>
                            •
                            <span
                              class="span__block-overflow"
                              style="margin-block: -5px"
                            >
                              {{
                                fn_convertExecutorPhoneNumber(activityDetail)
                              }}
                            </span>
                            •
                            <span
                              class="span__block-overflow-200"
                              style="margin-block: -5px"
                            >
                              {{ fn_convertExecutorPosition(activityDetail) }}
                            </span>
                          </span>
                        </div>
                      </div>

                      <div
                        class="d-flex mt-3"
                        v-if="
                          (activityDetail.note ||
                            activityDetail.type == 'TRANSFERED' ||
                            (activityDetail.type == 'REQUEST_DRAFF_SIGN' &&
                              activityDetail.from_user_name) ||
                            (activityDetail.type == 'REQUEST_SIGN' &&
                              activityDetail.from_user_name)) &&
                          i + 1 == activity.length
                        "
                      >
                        <i class="icon icon24-QuanLyCongViec c-orange mr-2"></i>
                        <div class="block-history-note">
                          <div
                            class="text-overflow-2 mb-0"
                            :title="
                              (activityDetail.from_user_name
                                ? activityDetail.from_user_name + ' : '
                                : '') +
                              (activityDetail.note ? activityDetail.note : '')
                            "
                          >
                            <p class="mr-1 mb-0">
                              <span
                                class="mr-1"
                                v-if="
                                  activityDetail.from_user_name ||
                                  (activityDetail.type == 'CREATED' &&
                                    activityDetail.from_user_info &&
                                    mData.dataForm.ref_id) ||
                                  activityDetail.type == 'TRANSFERED'
                                "
                                >Từ</span
                              >
                              <span
                                :class="{
                                  'span__block-overflow font-weight-bold': true,
                                  'c-red':
                                    activityDetail.from_user_status !==
                                      'DANG_LAM_VIEC' &&
                                    !activityDetail.from_company_info,
                                }"
                                v-if="
                                  activityDetail.from_user_name ||
                                  (activityDetail.type == 'CREATED' &&
                                    activityDetail.from_user_info &&
                                    mData.dataForm.ref_id) ||
                                  activityDetail.type == 'TRANSFERED'
                                "
                                >{{
                                  fn_convertActionFromPerson(activityDetail)
                                }}</span
                              >
                              <span v-if="activityDetail.note">
                                {{
                                  activityDetail.from_user_name ? " : " : " "
                                }}
                                {{
                                  activityDetail.note ? activityDetail.note : ""
                                }}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
            <!-- Start Tab Body -->

            <!-- Start Tab Body -->
          </el-tab-pane>
          <!-- End Tab LichSuXuLy -->
        </el-tabs>
      </b-col>
      <!-- Start Preview File -->
      <b-col md="7" class="pr-0 right-side">
        <div class="preview-wrapper">
          <div v-if="!isPdf" class="preview__file-container">
            <iframe
              :src="getOfficeViewerUrl(url)"
              style="width: 100%; height: 100%; border: 0"
            ></iframe>
          </div>
          <div v-if="isPdf" class="preview__file-container pdf-content">
            <ViewPdf
              :fileId="fileId"
              :currentPage="1"
              :syncDropzoneWidth="false"
            />
          </div>
          <div
            v-if="url"
            class="text-center preview__file-footer"
            @click="fn_viewFullScreen"
          >
            <p class="text-white">Xem toàn màn hình</p>
          </div>
        </div>
      </b-col>
      <!-- End Preview File -->
      <!-- Start Manipulate button -->
      <div class="button__group text-right mt-3 pb-1 pr-0 w-100">
        <div>
          <el-button
            class="btn__doc btn__doc-back"
            @click="openDocumentMoreInformation"
            v-if="checkRoleDocument()"
          >
            Thông tin lưu trữ
          </el-button>
        </div>
        <div>
          <el-button class="btn__doc btn__doc-back" @click="fn_goToList">
            Quay lại
          </el-button>
          <el-button class="btn__doc btn__doc-download" @click="fn_downloadFile">Tải file</el-button>
          <el-button
            v-if="fn_conditionShowRecallButton()"
            class="btn__doc btn__doc-recall"
            @click="fn_handle('recall')"
          >
            Thu hồi văn bản
          </el-button>
          <el-button
            v-if="fn_conditionShowCreateDraftButton()"
            class="btn__doc btn__doc-back"
            @click="fn_goToCreateFromDetail"
            >Tạo dự thảo</el-button
          >
          <el-button
            v-if="fn_conditionShowTransferButton()"
            class="btn__doc btn__doc-transfer"
            @click="fn_handle('transfer')"
            >Chuyển văn bản</el-button
          >
          <el-button
            v-if="fn_conditionShowRejectButton()"
            class="btn__doc btn__doc-recall"
            @click="fn_handle('reject-sign')"
            >Từ chối ký
          </el-button>
          <el-button
            v-if="fn_conditionShowRequestSignTempButton()"
            class="btn__doc btn__doc-back"
            @click="fn_handle('request-temp')"
            >Yêu cầu ký nháy</el-button
          >
          <el-button
            v-if="fn_conditionShowSignButton()"
            class="btn__doc btn__doc-transfer"
            @click="fn_handle('sign')"
            > {{isDigitalSignature?'Ký điện tử':'Ký duyệt' }}</el-button
          >
          <el-button
            v-if="fn_conditionShowPublishButton()"
            class="btn__doc btn__doc-transfer"
            @click="fn_handle('promulgate')"
            >Ban hành văn bản</el-button
          >
          <el-button
            v-if="fn_conditionShowCancelRequestSignButton()"
            class="btn__doc btn__doc-recall"
            @click="fn_handle('cancel-signing-process')"
            >Hủy trình ký
          </el-button>
          <el-button
            v-if="fn_conditionShowRecreateButton()"
            class="btn__doc btn__doc-transfer"
            @click="fn_handle('recreate')"
            >Tạo lại văn bản</el-button
          >
          <el-button
            v-if="isShowBtnDocSignTemp"
            class="btn__doc btn__doc-recall"
            @click="fn_handle('reject-sign-temp')"
            >Từ chối ký nháy
          </el-button>
          <el-button
            v-if="isShowBtnDocSignTemp"
            class="btn__doc btn__doc-transfer"
            @click="fn_handle('sign-temp')"
            >Ký nháy</el-button
          >
          <el-button
            v-if="
              mData.dataForm.author_id == mData.currentUser.id &&
              mData.dataForm.status == 'NEW'
            "
            class="btn__doc btn__doc-back"
            @click="fn_handle('edit')"
            >Chỉnh sửa</el-button
          >
          <el-button
            v-if="fn_conditionShowRequestSignButton()"
            class="btn__doc btn__doc-transfer"
            @click="fn_handle('request-sign')"
            >{{ fn_showTextButton() }}</el-button
          >
          <el-button
            v-if="fn_conditionShowTransferToOtherCompanyButton()"
            class="btn__doc btn__doc-transfer"
            @click="fn_handle('transfer-for-other-company')"
            >Chuyển cho công ty</el-button
          >
          <!-- <el-button
            v-if="
              !mData.dataForm.is_transfer_back &&
              mData.dataForm.ref_id &&
              (mData.dataForm.status == 'SIGNED' ||
                mData.dataForm.status == 'PUBLISHED')
            "
            class="btn__doc btn__doc-transfer"
            style="width: 190px"
            @click="fn_handle('transfer-back-to-original-company')"
            >Chuyển về công ty gốc</el-button
          > -->
        </div>
      </div>
      <!-- End Manipulate button -->
    </b-row>

    <!-- Start dialog Recall -->
    <el-dialog
      :visible.sync="dialogRecall"
      :show-close="false"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="text-center">
        <img
          class="m-2"
          src="img/Confirmation_question-mark.png"
          alt="Warning picture here!"
        />
      </div>
      <div class="text-center">
        <p class="dialog__text-warning font-xl" :title="mData.dataForm.name">
          Xác nhận Thu hồi văn bản <br />
          "{{
            mData.dataForm.name
              ? mData.dataForm.name
              : mData.dataForm.document_category_name
              ? mData.dataForm.document_category_name
              : "Không xác định"
          }}"
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRecall = false" class="btn__doc btn__doc-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_submitFormDialog('recall')"
          class="btn__doc btn__doc-recall"
          >Thu hồi</el-button
        >
      </span>
    </el-dialog>
    <!-- End dialog Recall -->

    <!-- Start dialog Cancel signing process -->
    <el-dialog
      :visible.sync="dialogCancelSigningProcess"
      :show-close="false"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="text-center">
        <img
          class="m-2"
          src="img/Confirmation_question-mark.png"
          alt="Warning picture here!"
        />
      </div>
      <div class="text-center">
        <p class="dialog__text-warning font-xl" :title="mData.dataForm.name">
          Xác nhận Hủy trình ký văn bản <br />
          "{{
            mData.dataForm.name
              ? mData.dataForm.name
              : mData.dataForm.document_category_name
              ? mData.dataForm.document_category_name
              : "Không xác định"
          }}"
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogCancelSigningProcess = false"
          class="btn__doc btn__doc-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_submitFormDialog('cancel-signing-process')"
          class="btn__doc btn__doc-recall"
          >Hủy trình ký</el-button
        >
      </span>
    </el-dialog>
    <!-- End dialog Cancel signing process -->

    <!-- Start dialog Reject sign -->
    <el-dialog
      :visible.sync="dialogRejectSign"
      :show-close="false"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <div class="text-center">
        <img
          class="m-2"
          src="img/Confirmation_question-mark.png"
          alt="Warning picture here!"
        />
      </div>
      <div class="text-center">
        <p class="dialog__text-warning font-xl" :title="mData.dataForm.name">
          Xác nhận Từ chối ký duyệt văn bản <br />
          "{{
            mData.dataForm.name
              ? mData.dataForm.name
              : mData.dataForm.document_category_name
              ? mData.dataForm.document_category_name
              : "Không xác định"
          }}"
        </p>
      </div>
      <el-form
        ref="formRejectSign"
        :model="mData.dataFormRejectSign"
        :rules="mData.validFormRejectSign"
        @submit.native.prevent
        label-position="top"
        style="width: 80%; margin: 0 auto; border: none"
      >
        <b-row>
          <b-col>
            <el-form-item label="Lý do từ chối" prop="rejectReason">
              <el-input
                type="textarea"
                v-model="mData.dataFormRejectSign.rejectReason"
                placeholder="Nhập nội dung"
                clearable
                show-word-limit
                maxlength="2000"
                resize="none"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="fn_closeDialogRejectSign"
          class="btn__doc btn__doc-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_submitFormDialog('reject-sign')"
          class="btn__doc btn__doc-recall"
          >Từ chối ký duyệt</el-button
        >
      </span>
    </el-dialog>
    <!-- End dialog Reject sign -->

    <!-- Start dialog Reject sign -->
    <el-dialog
      :visible.sync="dialogRejectSignTemp"
      :show-close="false"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <div class="text-center">
        <img
          class="m-2"
          src="img/Confirmation_question-mark.png"
          alt="Warning picture here!"
        />
      </div>
      <div class="text-center">
        <p class="dialog__text-warning font-xl" :title="mData.dataForm.name">
          Xác nhận Từ chối ký nháy văn bản <br />
          "{{
            mData.dataForm.name
              ? mData.dataForm.name
              : mData.dataForm.document_category_name
              ? mData.dataForm.document_category_name
              : "Không xác định"
          }}"
        </p>
      </div>
      <el-form
        ref="formRejectSignTemp"
        :model="mData.dataFormRejectSign"
        :rules="mData.validFormRejectSign"
        @submit.native.prevent
        label-position="top"
        style="width: 80%; margin: 0 auto; border: none"
      >
        <b-row>
          <b-col>
            <el-form-item label="Lý do từ chối" prop="rejectReason">
              <el-input
                type="textarea"
                v-model="mData.dataFormRejectSign.rejectReason"
                placeholder="Nhập nội dung"
                clearable
                show-word-limit
                maxlength="2000"
                resize="none"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="fn_closeDialogRejectSignTemp"
          class="btn__doc btn__doc-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_submitFormDialog('reject-sign-temp')"
          class="btn__doc btn__doc-recall"
          >Từ chối ký nháy</el-button
        >
      </span>
    </el-dialog>
    <!-- End dialog Reject sign -->

    <!-- Start dialog Transfer back to original company -->
    <el-dialog
      :visible.sync="dialogTransferBackToOriginalCompany"
      :show-close="false"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <div class="text-center">
        <img
          class="m-2"
          src="img/Confirmation_question-mark.png"
          alt="Warning picture here!"
        />
      </div>
      <div class="text-center">
        <p
          class="font-xl mt-3 mb-3"
          title="Bạn có chắc muốn chuyển văn bản về công ty gốc."
        >
          Bạn có chắc muốn chuyển văn bản về công ty gốc.
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="fn_closeDialogTransferBackToOriginalCompany"
          class="btn__doc btn__doc-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_transferBackToOriginalCompany()"
          class="btn__doc btn__doc-transfer"
          >Đồng ý</el-button
        >
      </span>
    </el-dialog>
    <!-- End dialog Transfer back to original company -->

    <!-- Start dialog Preview file -->
    <div v-if="isPreviewFile" class="preview-container">
      <!-- Start Preview File -->
      <div
        v-if="!isPdfViewFull"
        class="preview__file-container"
        :style="
          drawerVisible ? 'left: 25%; width: 75%' : 'left: 3%; width: 97%'
        "
      >
        <iframe
          :src="getOfficeViewerUrl(urlViewFull)"
          name="iframe_preview_doc"
          style="width: 100%; height: 100%; border: 0"
        ></iframe>
      </div>
      <div
        v-if="isPdfViewFull"
        class="preview__file-container pdf-content"
        :style="
          drawerVisible ? 'left: 25%; width: 75%' : 'left: 3%; width: 97%'
        "
      >
        <ViewPdf
          :fileId="fileId"
          :currentPage="1"
          :syncDropzoneWidth="false"
        />
      </div>
      <!-- End Preview File -->
      <div class="drawer-container">
        <!-- Start full drawer -->
        <div v-if="drawerVisible" class="drawer">
          <div class="drawer__back-icon">
            <i
              class="icon el-icon-back c-white"
              style="padding: 22px; font-size: 20px"
              title="Quay về"
              @click="isPreviewFile = false"
            ></i>
          </div>
          <div
            class="drawer__header d-flex justify-content-end align-items-center"
          >
            <i
              class="icon el-icon-d-arrow-left mt-1 mr-2"
              @click="fn_toggleDrawer()"
            ></i>
            <p class="drawer__header-title mb-0">Thu gọn</p>
          </div>
          <div class="drawer__box">
            <el-collapse v-model="activeCollapse">
              <el-collapse-item title="Văn bản" name="1">
                <ul>
                  <li
                    @click="
                      fn_checkFileType(
                        mData.dataForm.publish.published_file_id
                          ? mData.dataForm.publish.published_file_id
                          : mData.dataForm.signed_doc_file_id
                          ? mData.dataForm.signed_doc_file_id
                          : mData.fileUploadOption.fileMain.fileList[0]
                      )
                    "
                  >
                    <a :href="!isPdfViewFull ? getOfficeViewerUrl(urlViewFull) : getPdfViewerUrl(urlViewFull)" 
                       :target="!isPdfViewFull ? 'iframe_preview_doc': '_blank'">{{
                      mData.fileUploadOption.fileMain.fileList[0].name
                    }}</a>
                  </li>
                </ul>
              </el-collapse-item>
              <el-collapse-item title="File đính kèm" name="2">
                <ul
                  v-for="file in mData.fileUploadOption.fileOther.fileList"
                  :key="file.id"
                >
                  <li @click="fn_checkFileType(file)">
                    <a>{{ file.name }}</a>
                    <!-- <el-link type="info">info</el-link> -->
                  </li>
                </ul>
              </el-collapse-item>
            </el-collapse>
          </div>
          <!-- End main Sign images -->
        </div>
        <!-- End full drawer -->

        <!-- Start collapse drawer -->
        <div class="drawer-collapse" v-else>
          <div>
            <div class="drawer__header d-flex align-items-center">
              <div style="height: 56px; background-color: #292d32">
                <i
                  class="icon el-icon-back c-white"
                  style="padding: 5px; font-size: 20px"
                  title="Quay về"
                  @click="isPreviewFile = false"
                ></i>
              </div>
              <i
                class="icon el-icon-d-arrow-right mb-1"
                @click="fn_toggleDrawer"
              ></i>
              <p
                class="drawer__header-title"
                style="cursor: pointer"
                @click="fn_toggleDrawer"
              >
                Thanh công cụ
              </p>
            </div>
          </div>
        </div>
        <!-- End collapse drawer -->
      </div>
    </div>
    <!-- End dialog Preview file -->

    <!-- Dialog thông tin thêm của lưu trữ -->
    <el-dialog
      class="document-more-information"
      title="Thông tin lưu trữ"
      :visible.sync="dialogMoreInformation"
      width="80%"
      top="1vh"
      :before-close="beforeCloseDialogMoreInformation"
      :close-on-click-modal="false"
    >
      <el-form
        ref="documentMoreInformationForm"
        :model="mData.moreInformationForm"
        label-width="220px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="24">
              <el-form-item label="Mã định danh cơ quan">
                <el-input
                  placeholder="Nhập mã định danh cơ quan"
                  v-model="mData.moreInformationForm.identity"
                  @change="
                    () => {
                      mData.moreInformationForm.identity =
                        mData.moreInformationForm.identity.toUpperCase();
                    }
                  "
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Mã cơ quan lưu trữ">
                <el-input
                  placeholder="Nhập mã cơ quan lưu trữ"
                  v-model="mData.moreInformationForm.history_archive_code"
                  @change="
                    () => {
                      mData.moreInformationForm.history_archive_code =
                        mData.moreInformationForm.history_archive_code.toUpperCase();
                    }
                  "
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Cơ quan lưu trữ lịch sử">
                <el-input
                  placeholder="Nhập cơ quan lưu trữ lịch sử"
                  v-model="mData.moreInformationForm.history_archive"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Năm hình thành hồ sơ">
                <el-input-number
                  placeholder="Nhập năm hình thành hồ sơ"
                  v-model="mData.moreInformationForm.doc_year_formation"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Phân loại hồ sơ">
                <el-input
                  placeholder="Nhập loại hồ sơ"
                  v-model="mData.moreInformationForm.file_classification"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Tổng số văn bản trong hồ sơ">
                <el-input-number
                  placeholder="Nhập tổng số văn bản trong hồ sơ"
                  v-model="mData.moreInformationForm.doc_file_count"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Folder lưu trữ">
                <el-input
                  placeholder="Nhập folder lưu trữ"
                  v-model="mData.moreInformationForm.folder_save"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Vị trí lưu">
                <el-input
                  placeholder="Nhập vị trí lưu"
                  v-model="mData.moreInformationForm.location_save"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Giá, kệ">
                <el-input
                  placeholder="Nhập giá, kệ"
                  v-model="mData.moreInformationForm.shelf"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Hộp, cặp">
                <el-input
                  placeholder="Nhập hộp, cặp"
                  v-model="mData.moreInformationForm.bag"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Kho lưu trữ">
                <el-input
                  placeholder="Nhập kho lưu trữ"
                  v-model="mData.moreInformationForm.storage"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Đơn vị nộp lưu">
                <el-input
                  placeholder="Nhập đơn vị nộp lưu"
                  v-model="mData.moreInformationForm.depository_unit"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Ký hiệu thông tin">
                <el-input
                  placeholder="Nhập ký hiệu thông tin"
                  v-model="mData.moreInformationForm.info_symbol"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Mục lục">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                  placeholder="Nhập mục lục"
                  v-model="mData.moreInformationForm.table_of_contents"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="24">
              <el-form-item label="Mã Barcode">
                <el-input
                  placeholder="Nhập mã Barcode"
                  v-model="mData.moreInformationForm.barcode"
                  @change="
                    () => {
                      mData.moreInformationForm.barcode =
                        mData.moreInformationForm.barcode.toUpperCase();
                    }
                  "
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Phông">
                <el-input
                  placeholder="Nhập phông"
                  v-model="mData.moreInformationForm.font_family"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Ngôn ngữ">
                <el-input
                  placeholder="Nhập ngôn ngữ"
                  v-model="mData.moreInformationForm.language"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Tình trạng vật lý">
                <el-input
                  placeholder="Nhập tình trạng vật lý"
                  v-model="mData.moreInformationForm.physical_status"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Số lượng trang">
                <el-input-number
                  placeholder="Nhập số lượng trang"
                  v-model="mData.moreInformationForm.number_of_pages"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Số lượng tờ">
                <el-input-number
                  placeholder="Nhập số lượng tờ"
                  v-model="mData.moreInformationForm.number_of_sheets"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Năm lưu trữ">
                <el-input-number
                  placeholder="Nhập năm lưu trữ"
                  v-model="mData.moreInformationForm.year_save"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Số năm lưu trữ">
                <el-input-number
                  placeholder="Nhập số năm lưu trữ"
                  v-model="mData.moreInformationForm.number_of_year_save"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Thời gian bắt đầu">
                <el-date-picker
                  placeholder="Chọn thời gian bắt đầu"
                  v-model="mData.moreInformationForm.start_time"
                  type="date"
                  format="dd/MM/yyyy"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Thời gian kết thúc">
                <el-date-picker
                  placeholder="Chọn thời gian kết thúc"
                  v-model="mData.moreInformationForm.end_time"
                  type="date"
                  format="dd/MM/yyyy"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Thời hạn bảo quản">
                <el-date-picker
                  placeholder="Chọn thời hạn bảo quản"
                  v-model="mData.moreInformationForm.shelf_life_time"
                  type="date"
                  format="dd/MM/yyyy"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Chế độ sử dụng">
                <el-input
                  placeholder="Nhập chế độ sử dụng"
                  v-model="mData.moreInformationForm.usage_mode"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Từ khóa">
                <el-input
                  placeholder="Nhập từ khóa"
                  v-model="mData.moreInformationForm.key_words"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Chú giải">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                  maxlength="500"
                  show-word-limit
                  resize="none"
                  placeholder="Nhập chú giải"
                  v-model="mData.moreInformationForm.note"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button
          class="btn__doc btn__doc-recall"
          @click="beforeCloseDialogMoreInformation"
        >
          Đóng
        </el-button>
        <el-button
          class="btn__doc btn__doc-transfer"
          @click="saveDocumentMoreInformation"
        >
          Lưu
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ValidService from "../../../service/ValidService";
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import DocumentApi from "../../../moduleApi/DocumentApi";
import DocumentCategoryApi from "../../../moduleApi/DocumentCategoryApi";
import DocumentBusinessApi from "../../../moduleApi/DocumentBusinessApi";
import DepartmentApi from "../../../moduleApi/DepartmentApi";
import BookApi from "../../../moduleApi/BookApi";
import FileApi from "../../../moduleApi/FileApi";
import DocumentModel from "./DocumentModel";
import { dataDocMixins } from "./DocumentMixins/dataDocMixins";
import { fnDocMixins } from "./DocumentMixins/fnDocMixins";
import ViewPdf from "@/component/Draggable/ViewPdf";
import _ from "lodash";
import { sign } from "core-js/core/number";

export default {
  mixins: [dataDocMixins, fnDocMixins],
  components: {
    ViewPdf,
  },
  data() {
    return {
      MethodService,
      mData: {
        dataDetail: [],
        moreInformationForm: MethodService.copyObject(
          DocumentModel.dataFormDocumentMoreInformation
        ),
        moreInformationFormBefore: MethodService.copyObject(
          DocumentModel.dataFormDocumentMoreInformation
        ),
      },
      url: "",
      fileExtension: "",
      isDigitalSignature: false,
      urlViewFull: "",
      fileExtensionViewFull: "",
      isPdf: false,
      isPdfViewFull: false,
      isPreviewFile: false,
      drawerVisible: true,
      listDocHistory: [],
      docType: "",
      activeCard: "ChiTietVanBan",
      activeCollapse: ["1", "2"],
      dialogRejectSign: false,
      dialogRejectSignTemp: false,
      isWaitingForSignTemp: false,
      isHideDeadline: true,
      isShowBtnDocSignTemp: false,
      reverse: true,
      isSigned: false,
      isSignedBySomeone: false,
      isTempSigned: false,
      isRejectTempSigned: false,
      loadDepartment: false,
      listDepartment: [],
      loadingStatus: false,
      isEditBookNumber: false,
      isHideButton: false,
      isHideBtnRequestSign: false,
      isPublished: false,
      dialogTransferBackToOriginalCompany: false,
      dialogMoreInformation: false,
    };
  },

  methods: {
    getOfficeViewerUrl(fileUrl) {
      return fileUrl ? ExtensionService.getOfficeViewerUrl(fileUrl) : "";
    },

    getPdfViewerUrl(fileUrl) {
      if (!fileUrl) return "";
      return fileUrl.replace("file/thumb?id=", "file/download?id=");
    },

    openDocumentMoreInformation() {
      this.dialogMoreInformation = true;
    },

    saveDocumentMoreInformation() {
      this.$refs["documentMoreInformationForm"].validate(async (valid) => {
        if (!valid) {
          MethodService.stopLadda();
          return false;
        }
        try {
          let dataUpdate = {
            id: this.mData.dataForm.id,
            more_info: this.mData.moreInformationForm,
          };
          await DocumentApi.update(dataUpdate);
          this.$notify.success({
            message: "Cập nhật thông tin lưu trữ thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          this.fn_getDocById(this.$route.params.id);
          this.beforeCloseDialogMoreInformation();
        } catch (error) {
          this.$notify.error({
            message: "Cập nhật thông tin lưu trữ thất bại.",
            duration: 3000,
            customClass: "doc-error",
          });
        }
      });
    },

    beforeCloseDialogMoreInformation() {
      this.$refs["documentMoreInformationForm"].resetFields();
      this.mData.moreInformationForm = MethodService.copyObject(
        this.mData.moreInformationFormBefore
      );
      this.dialogMoreInformation = false;
    },

    checkRoleDocument() {
      if (!this.listRole || this.listRole.length == 0) return false;
      if (this.listRole.includes("VT")) return true;
    },

    async fn_transferBackToOriginalCompany() {
      try {
        const res = await DocumentApi.findById(this.$route.params.id);
        if (res.result && res.result.is_transfer_back) {
          this.$notify.info({
            message: `Văn bản này hiện đã được chuyển về công ty công ty gốc.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.dialogTransferBackToOriginalCompany = false;
          await this.fn_getDocById(this.$route.params.id);
          return;
        }

        const documentInApiRes =
          await DocumentApi.TransferDocumentAgainToRefCompany(
            this.$route.params.id
          );
        if (documentInApiRes.result) {
          this.$notify.success({
            message: "Chuyển văn bản thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          await this.fn_getDocById(this.$route.params.id);
          this.dialogTransferBackToOriginalCompany = false;
        }
      } catch (error) {
        if (error.code == 404) {
          this.$notify.warning({
            message: `${error.detail}.`,
            duration: 3000,
            customClass: "doc-warning",
          });
          this.dialogTransferBackToOriginalCompany = false;
          return;
        }
        this.$notify.warning({
          message: `Chuyển văn bản thất bại.`,
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    fn_checkHadTransferedToOtherCompany(data) {
      if (data && data.status == "TRANSFERED_OTHER_COMPANY") {
        return true;
      } else return false;
    },

    async fn_updateBookNumber() {
      this.$refs["formEditBookNumber"].validate(async (valid) => {
        if (!valid) return;
        try {
          const res = await DocumentApi.update({
            id: this.mData.dataForm.id,
            book_number: this.mData.dataFormEditBookNumber.newBookNumber,
          });
          if (res.result) {
            this.$notify.success({
              message: "Cập nhật số văn bản thành công.",
              duration: 3000,
              customClass: "doc-success",
            });
            this.mData.dataForm.book_number =
              this.mData.dataFormEditBookNumber.newBookNumber;
            await this.fn_cancelBookNumber();
          }
        } catch (error) {
          // console.log(error);
          if (error.code == 500) {
            this.$notify.warning({
              message: `${error.detail}`,
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          }
          this.$notify.warning({
            message: "Cập nhật số văn bản thất bại.",
            duration: 3000,
            customClass: "doc-warning",
          });
        }
      });
    },

    fn_clickEditBookNumber() {
      this.isEditBookNumber = true;
      this.mData.dataFormEditBookNumber.newBookNumber =
        this.mData.dataForm.book_number;
    },

    fn_cancelBookNumber() {
      this.$refs["formEditBookNumber"].resetFields();
      this.isEditBookNumber = false;
    },

    getNameDepartment(departmentId) {
      let department = this.listDepartment.find(
        (item) => item.id == departmentId
      );
      return department && department.name ? department.name : "";
    },

    handleClick(tab, event) {
      // console.log(tab, event);
    },

    fn_showDeadlineManipulately() {
      let deadlineTempSign = "";
      let data = this.mData.dataForm;
      if (data.status == "WAITING_FOR_SIGN") {
        if (
          this.$route.query.type == "DOC_SIGN_TEMP" &&
          data.signers &&
          data.signers.length > 0
        ) {
          const objSigner = data.signers.find(
            (signer) =>
              signer.status == "WAITING" ||
              signer.status == "WAITING" ||
              signer.status == "SIGNED_FAILED"
          );
          if (
            objSigner &&
            objSigner.request_temp_signers &&
            objSigner.request_temp_signers.length > 0
          ) {
            const objTempSigner = objSigner.request_temp_signers.find(
              (tempSigner) =>
                (tempSigner.user_id == this.mData.currentUser.id &&
                  tempSigner.status == "NEW") ||
                (tempSigner.user_id == this.mData.currentUser.id &&
                  tempSigner.status == "WAITING") ||
                (tempSigner.user_id == this.mData.currentUser.id &&
                  tempSigner.status == "SIGNED_FAILED")
            );
            if (objTempSigner) {
              deadlineTempSign = objTempSigner.deadline;
            }
          }
        }
      }
      return (this.docType == "DOC_SIGN_CONSENT" &&
        this.mData.dataForm.deadline) ||
        (this.docType == "DOC_SIGN" && this.mData.dataForm.deadline) ||
        (this.docType == "DOC_IN" && this.mData.dataForm.deadline) ||
        (this.docType == "DOC_OUT" && this.mData.dataForm.deadline)
        ? this.fn_formatDate(this.mData.dataForm.deadline)
        : this.docType == "DOC_SIGN_TEMP" && deadlineTempSign
        ? this.fn_formatDate(deadlineTempSign)
        : "--/--/--";
    },

    fn_showTextButton() {
      return ((!this.$route.query.from ||
        this.$route.query.from == "create" ||
        this.$route.query.from == "recreate" ||
        this.$route.query.from == "edit") &&
        (!this.mData.dataForm.signers ||
          this.mData.dataForm.signers.length == 0 ||
          (this.mData.dataForm.signers.length > 0 &&
            !this.mData.dataForm.signers[0].position &&
            !this.mData.dataForm.signers[0].is_add_auto) ||
          (this.mData.dataForm.signers[0].is_add_auto &&
            !this.mData.dataForm.signers[1].position))) ||
        (this.mData.dataForm.signers && this.mData.dataForm.signers.length == 0)
        ? "Trình ký"
        : "Trình ký lại";
    },

    scrollToTop() {
      document.querySelector(".app-body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    fn_viewFullScreen() {
      this.isPreviewFile = true;
      this.scrollToTop();
    },

    fn_toggleDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },

    fn_checkFileType(file) {
      this.isPdfViewFull = file.extension == ".pdf" || !file.extension;
      this.urlViewFull = this.isPdfViewFull
        ? ExtensionService.getPdfPreviewUrl(file.id || file)
        : file.url
        ? file.url
        : ExtensionService.getDocumentPreviewUrl(file.id || file);
      console.log(this.urlViewFull);
    },

    fn_convertActivityName(type) {
      return type == "CREATED"
        ? "Tạo mới"
        : type == "UPDATED"
        ? "Cập nhật"
        : type == "TRANSFERED"
        ? "Đã chuyển tiếp"
        : type == "REQUEST_SIGN"
        ? "Trình ký"
        : type == "SIGNED_IMAGE"
        ? "Ký duyệt"
        : type == "REJECTED"
        ? "Từ chối ký duyệt"
        : type == "DRAFF_SIGNED"
        ? "Ký nháy"
        : type == "REQUEST_DRAFF_SIGN"
        ? "Trình ký nháy"
        : type == "DRAFF_SIGN_REJECTED"
        ? "Từ chối ký nháy"
        : type == "SIGNED_FAILED"
        ? "Ký duyệt thất bại"
        : type == "PUBLISHED"
        ? "Ban hành"
        : type == "RECALLED"
        ? "Thu hồi văn bản"
        : type == "REJECT_FOR_SIGN"
        ? "Hủy trình ký"
        : type == "TRANSFERED_OTHER_COMPANY"
        ? "Chuyển cho công ty khác"
        : type == "TRANSFERED_BACK"
        ? "Chuyển về công ty gốc"
        : type == "PARTNER_SIGNED"
        ? "Đối tác ký duyệt"
        : type == "PARTNER_REJECTED"
        ? "Đối tác từ chối"
        : "Không xác định";
    },

    async fn_getMainFile(docData) {
      if (docData && docData.doc_file && docData.doc_file.doc_id) {
        const listFile = await FileApi.list(
          {
            filters: `id=${docData.doc_file.doc_id}`,
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.urlDowloadFile + item.id;
          });
        }
        this.mData.fileUploadOption.fileMain.fileList = data;
      }
    },

    async fn_getOtherFiles(docData) {
      if (docData && docData.other_files && docData.other_files.length > 0) {
        const listFileId = docData.other_files.map((file) => file.other_id);
        const listFile = await FileApi.list(
          {
            limit: docData.other_files.length,
            filters: "id:in:" + listFileId.join(","),
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.urlDowloadFile + item.id;
          });
        }
        this.mData.fileUploadOption.fileOther.fileList = data;
      } else {
        docData.other_files = [];
      }
    },

    fn_buildHistoryTimeline(dataDoc) {
      if (dataDoc.histories && dataDoc.histories.length > 0) {
        const docHistory = dataDoc.histories.filter(
          (record) =>
            ((record.type == "DRAFF_SIGNED" ||
              record.type == "DRAFF_SIGN_REJECTED") &&
              (record.user_id == this.mData.currentUser.id ||
                record.from_user_id == this.mData.currentUser.id)) ||
            (record.type == "REQUEST_DRAFF_SIGN" &&
              (record.from_user_id == this.mData.currentUser.id ||
                record.user_id == this.mData.currentUser.id)) ||
            (record.type !== "DRAFF_SIGNED" &&
              record.type !== "DRAFF_SIGN_REJECTED" &&
              record.type !== "REQUEST_DRAFF_SIGN")
        );
        this.listDocHistory = dataDoc.histories
          ? _.groupBy(docHistory, "time_at")
          : [];
      }
    },

    fn_getMainFileURL(dataDoc) {
      if (!dataDoc) return;
      let fileDetail = {};
      this.isPdf = false;
      this.isPdfViewFull = false;
      this.url = "";
      this.urlViewFull = "";
      this.fileId = undefined;

      if (dataDoc.status === "PUBLISHED" && !dataDoc.publish.is_auto) {
        // Preview outside
        this.url = ExtensionService.getPdfPreviewUrl(
          dataDoc.publish.published_file_id
        );
        this.isPdf = true;
        // View full screen
        this.urlViewFull = ExtensionService.getPdfPreviewUrl(
          dataDoc.publish.published_file_id
        );
        this.isPdfViewFull = true;
        this.fileId = dataDoc.publish.published_file_id;
      } else if (dataDoc.signed_doc_file_id) {
        // Preview outside
        this.url = ExtensionService.getPdfPreviewUrl(
          dataDoc.signed_doc_file_id
        );
        this.isPdf = true;
        // View full screen
        this.urlViewFull = ExtensionService.getPdfPreviewUrl(
          dataDoc.signed_doc_file_id
        );
        this.isPdfViewFull = true;
        this.fileId = dataDoc.signed_doc_file_id;
      } else if (dataDoc.doc_file && dataDoc.doc_file.doc_id) {
        fileDetail = this.mData.fileUploadOption.fileMain.fileList[0];
        this.url = ExtensionService.getDocumentPreviewUrl(fileDetail.id);
        // View full screen
        this.urlViewFull =
          fileDetail.extension == ".pdf"
            ? ExtensionService.getPdfPreviewUrl(fileDetail.id)
            : ExtensionService.getDocumentPreviewUrl(fileDetail.id);
        this.isPdfViewFull = fileDetail.extension == ".pdf";
        this.fileId = fileDetail.id;
      } else {
        fileDetail = this.mData.fileUploadOption.fileOther.fileList[0];
        this.url =
          fileDetail.extension == ".pdf"
            ? ExtensionService.getPdfPreviewUrl(fileDetail.id)
            : ExtensionService.getDocumentPreviewUrl(fileDetail.id);
        this.urlViewFull =
          fileDetail.extension == ".pdf"
            ? ExtensionService.getPdfPreviewUrl(fileDetail.id)
            : ExtensionService.getDocumentPreviewUrl(fileDetail.id);
        this.isPdfViewFull = fileDetail.extension == ".pdf";
        this.fileId = fileDetail.id;
      }
      if (fileDetail.extension == ".pdf") {
        this.isPdf = true;
      }
    },

    fn_downloadFile() {
      if (this.fileId) {
        window.open(ExtensionService.urlDowloadFile + this.fileId);
      } else {
        this.$notify.warning({
          message: "Không tìm thấy file để tải.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    async fn_getDocById(id) {
      const documentInApiRes = await DocumentApi.findById(id);
      if (documentInApiRes.result) {
        if (
          this.checkStatusRejectForSign(documentInApiRes.result) &&
          this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED" &&
          documentInApiRes.result.status != "RECALLED"
        ) {
          this.fn_goToList();
          return;
        }
        await this.fn_getMainFile(documentInApiRes.result);
        this.fn_getOtherFiles(documentInApiRes.result);

        this.fn_checkHasSignTemp(documentInApiRes.result);
        this.fn_isHideDeadline(documentInApiRes.result);
        this.fn_checkShowBtnDocSignTemp(documentInApiRes.result);

        this.mData.dataForm = await this.fn_changeDataDoc(
          documentInApiRes.result
        );
        console.log('this.mData.dataForm: ',this.mData.dataForm);
        this.mData.moreInformationForm = documentInApiRes.result.more_info
          ? documentInApiRes.result.more_info
          : {};
        this.mData.moreInformationFormBefore = documentInApiRes.result.more_info
          ? MethodService.copyObject(documentInApiRes.result.more_info)
          : {};

        if (this.mData.dataForm.publish.department_id)
          this.getDepartment(this.mData.dataForm.publish.department_id);

        this.fn_buildHistoryTimeline(this.mData.dataForm);

        this.fn_eventBus(
          this.checkTab(this.docType),
          "detail",
          this.mData.dataForm.name
        );

        await this.fn_checkHasSign();
        await this.fn_checkDocIsSignedBySomeone();
        this.fn_getMainFileURL(this.mData.dataForm);
        this.fn_checkPublished(documentInApiRes.result);
      }
      this.loadingStatus = false;
    },

    fn_conditionDisplayBlockOtherCompanyRejected() {
      if (
        (this.mData.dataForm.status == "SIGNED" ||
          this.mData.dataForm.status == "PUBLISHED") &&
        this.mData.dataForm.transfer_to_companies &&
        this.mData.dataForm.transfer_to_companies.length > 0 &&
        this.mData.dataForm.transfer_to_companies[
          this.mData.dataForm.transfer_to_companies.length - 1
        ].status == "REJECTED"
      ) {
        return true;
      } else return false;
    },

    fn_conditionDisplayBlockOtherCompanySigned() {
      if (
        (this.mData.dataForm.status == "SIGNED" ||
          this.mData.dataForm.status == "PUBLISHED") &&
        this.mData.dataForm.transfer_to_companies &&
        this.mData.dataForm.transfer_to_companies.length > 0 &&
        this.mData.dataForm.transfer_to_companies[
          this.mData.dataForm.transfer_to_companies.length - 1
        ].status == "SIGNED"
      ) {
        return true;
      } else return false;
    },

    fn_conditionDisplayCheckIcon() {
      if (
        this.mData.dataForm.status == "SIGNED" ||
        (this.mData.dataForm.status == "SIGNED" && this.isSigned) ||
        (this.mData.dataForm.status == "WAITING_FOR_SIGN" && this.isSigned) ||
        (this.mData.dataForm.author_id !== this.mData.currentUser.id &&
          this.mData.dataForm.status == "PUBLISHED" &&
          this.isSigned)
      ) {
        return true;
      } else return false;
    },

    fn_conditionDisplaySignedOrPublished() {
      if (
        (this.mData.dataForm.status !== "REJECT_FOR_SIGN" &&
          this.mData.dataForm.status !== "REJECTED" &&
          this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED" &&
          !this.isRejectTempSigned) ||
        (this.mData.dataForm.status !== "REJECT_FOR_SIGN" &&
          this.mData.dataForm.status !== "REJECTED" &&
          this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED" &&
          !this.isRejectTempSigned &&
          this.docType !== "DOC_SIGN_TEMP")
      ) {
        return true;
      } else return false;
    },

    fn_convertDocRejectStatus() {
      return this.mData.dataForm.status == "REJECTED" &&
        this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED"
        ? "Đã từ chối"
        : (this.isRejectTempSigned && this.docType == "DOC_SIGN_TEMP") ||
          this.$route.query.statusFilter == "DOC_DRAFF_REJECTED"
        ? "Đã từ chối ký nháy"
        : "";
    },

    fn_convertDocStatusIsSignedOrPublished() {
      return (this.mData.dataForm.status == "PUBLISHED" &&
        (this.docType == "DOC_ISSUE" ||
          (this.docType == "FILTER" &&
            this.$route.query.filterType == "CBH" &&
            this.listRole &&
            this.listRole.includes("VT")))) ||
        (this.mData.dataForm.status == "PUBLISHED" &&
          this.mData.dataForm.author_id == this.mData.currentUser.id)
        ? "Đã ban hành"
        : (this.mData.dataForm.status == "SIGNED" && this.isSigned) ||
          (this.mData.dataForm.status == "WAITING_FOR_SIGN" &&
            this.isSigned &&
            this.$route.query.statusFilter !== "DOC_DRAFF_SIGNED" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED") ||
          (this.mData.dataForm.author_id !== this.mData.currentUser.id &&
            this.mData.dataForm.status == "PUBLISHED" &&
            this.isSigned &&
            this.$route.query.statusFilter !== "DOC_DRAFF_SIGNED" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED") ||
          (this.mData.dataForm.status == "RECALLED" &&
            this.isSigned &&
            this.docType != "DOC_ISSUE" &&
            this.docType != "DOC_OUT" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_SIGNED" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED")
        ? "Đã ký duyệt"
        : this.mData.dataForm.status_name;
    },

    fn_checkClassForActivitiesBlock(activityDetail) {
      return activityDetail.type == "CREATED"
        ? "block-yellow"
        : activityDetail.type == "REJECTED" ||
          activityDetail.type == "DRAFF_SIGN_REJECTED" ||
          activityDetail.type == "SIGNED_FAILED" ||
          activityDetail.type == "RECALLED" ||
          activityDetail.type == "REJECT_FOR_SIGN" ||
          activityDetail.type == "PARTNER_REJECTED"
        ? "block-red"
        : "block-turquoise";
    },

    fn_getSourceActivitiesAvt(activityDetail) {
      return activityDetail.type == "CREATED" &&
        activityDetail.from_company_info &&
        activityDetail.from_company_info.logo_company &&
        this.mData.dataForm.ref_id
        ? activityDetail.from_company_info.logo_company
        : (activityDetail.type == "CREATED" &&
            activityDetail.from_company_info &&
            !activityDetail.from_company_info.logo_company &&
            this.mData.dataForm.ref_id) ||
          ((activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
            activityDetail.from_company_info &&
            !activityDetail.from_company_info.logo_company) ||
          ((activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
            activityDetail.other_company_info &&
            !activityDetail.other_company_info.logo_company)
        ? "img/Vector-person.png"
        : (activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
          activityDetail.from_company_info &&
          activityDetail.from_company_info.logo_company
        ? activityDetail.from_company_info.logo_company
        : (activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
          activityDetail.other_company_info &&
          activityDetail.other_company_info.logo_company
        ? activityDetail.other_company_info.logo_company
        : (activityDetail.type == "CREATED" ||
            activityDetail.type == "UPDATED") &&
          activityDetail.from_user_avt &&
          activityDetail.user_id !== activityDetail.from_user_id
        ? activityDetail.from_user_avt
        : activityDetail.avt
        ? activityDetail.avt
        : "img/Vector-person.png";
    },

    fn_fillClassExecutor(activityDetail) {
      if (
        (activityDetail.user_status &&
          activityDetail.user_status !== "DANG_LAM_VIEC" &&
          this.mData.dataForm.status !== "SIGNED" &&
          this.mData.dataForm.status !== "PUBLISHED" &&
          this.mData.dataForm.status !== "TRANSFERED_OTHER_COMPANY") ||
        (this.mData.dataForm.status !== "SIGNED" &&
          this.mData.dataForm.status !== "PUBLISHED" &&
          this.mData.dataForm.status !== "REJECTED" &&
          this.mData.dataForm.is_transfer_back)
      ) {
        return true;
      } else return false;
    },

    fn_convertExecutorName(activityDetail) {
      return (activityDetail.type == "PARTNER_SIGNED" ||
        activityDetail.type == "PARTNER_REJECTED") &&
        activityDetail.other_company_info
        ? activityDetail.from_company_info.name
        : (activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
          activityDetail.other_company_info
        ? activityDetail.other_company_info.name
        : activityDetail.type == "CREATED" &&
          activityDetail.from_company_info &&
          this.mData.dataForm.ref_id
        ? activityDetail.from_company_info.name
        : (activityDetail.type == "CREATED" ||
            activityDetail.type == "UPDATED") &&
          activityDetail.from_user_name &&
          activityDetail.user_id !== activityDetail.from_user_id
        ? activityDetail.from_user_name
        : activityDetail.user_name
        ? activityDetail.user_name
        : activityDetail.from_user_id == this.mData.currentCompany.id
        ? this.mData.currentCompany.name.name_vi
        : "";
    },

    fn_convertExecutorNo(activityDetail) {
      return activityDetail.type == "CREATED" &&
        activityDetail.from_company_info &&
        activityDetail.from_company_info.abbr &&
        this.mData.dataForm.ref_id
        ? activityDetail.from_company_info.abbr
        : (activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
          activityDetail.from_company_info &&
          activityDetail.from_company_info.abbr
        ? activityDetail.from_company_info.abbr
        : ((activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
            activityDetail.from_company_info &&
            !activityDetail.from_company_info.abbr) ||
          (activityDetail.type == "CREATED" &&
            activityDetail.from_company_info &&
            !activityDetail.from_company_info.abbr &&
            this.mData.dataForm.ref_id) ||
          ((activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
            activityDetail.other_company_info &&
            !activityDetail.other_company_info.abbr)
        ? "---"
        : (activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
          activityDetail.other_company_info &&
          activityDetail.other_company_info.abbr
        ? activityDetail.other_company_info.abbr
        : (activityDetail.type == "CREATED" ||
            activityDetail.type == "UPDATED") &&
          activityDetail.from_user_no &&
          activityDetail.user_id !== activityDetail.from_user_id
        ? activityDetail.from_user_no
        : activityDetail.user_no
        ? activityDetail.user_no
        : "---";
    },

    fn_convertExecutorPhoneNumber(activityDetail) {
      return activityDetail.type == "CREATED" &&
        activityDetail.from_company_info &&
        activityDetail.from_company_info.phone_number &&
        this.mData.dataForm.ref_id
        ? activityDetail.from_company_info.phone_number
        : (activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
          activityDetail.from_company_info &&
          activityDetail.from_company_info.phone_number
        ? activityDetail.from_company_info.phone_number
        : ((activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
            activityDetail.from_company_info &&
            !activityDetail.from_company_info.phone_number) ||
          ((activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
            activityDetail.other_company_info &&
            !activityDetail.other_company_info.phone_number) ||
          ((activityDetail.type == "CREATED" ||
            activityDetail.type == "UPDATED") &&
            !activityDetail.from_user_phone_number &&
            activityDetail.user_id !== activityDetail.from_user_id)
        ? "**** *** ***"
        : (activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
          activityDetail.other_company_info &&
          activityDetail.other_company_info.phone_number
        ? activityDetail.other_company_info.phone_number
        : (activityDetail.type == "CREATED" ||
            activityDetail.type == "UPDATED") &&
          activityDetail.from_user_phone_number &&
          activityDetail.user_id !== activityDetail.from_user_id
        ? activityDetail.from_user_phone_number
        : activityDetail.phone_number
        ? activityDetail.phone_number
        : activityDetail.from_user_id == this.mData.currentCompany.id
        ? this.mData.currentCompany.phone_number.phone_number
        : "**** *** ***";
    },

    fn_convertExecutorPosition(activityDetail) {
      return activityDetail.type == "CREATED" &&
        activityDetail.from_company_info &&
        activityDetail.from_company_info.tax_number &&
        this.mData.dataForm.ref_id
        ? activityDetail.from_company_info.tax_number
        : (activityDetail.type == "CREATED" &&
            activityDetail.from_company_info &&
            !activityDetail.from_company_info.tax_number &&
            this.mData.dataForm.ref_id) ||
          ((activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
            activityDetail.from_company_info &&
            !activityDetail.from_company_info.tax_number) ||
          ((activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
            activityDetail.other_company_info &&
            !activityDetail.other_company_info.tax_number)
        ? "---"
        : (activityDetail.type == "PARTNER_SIGNED" ||
            activityDetail.type == "PARTNER_REJECTED") &&
          activityDetail.from_company_info &&
          activityDetail.from_company_info.tax_number
        ? activityDetail.from_company_info.tax_number
        : (activityDetail.type == "TRANSFERED_OTHER_COMPANY" ||
            activityDetail.type == "TRANSFERED_BACK") &&
          activityDetail.other_company_info &&
          activityDetail.other_company_info.tax_number
        ? activityDetail.other_company_info.tax_number
        : (activityDetail.type == "CREATED" ||
            activityDetail.type == "UPDATED") &&
          activityDetail.from_user_position_name &&
          activityDetail.user_id !== activityDetail.from_user_id
        ? activityDetail.from_user_position_name
        : activityDetail.user_position_name
        ? activityDetail.user_position_name
        : activityDetail.position_name
        ? activityDetail.position_name
        : "---";
    },

    fn_convertActionFromPerson(activityDetail) {
      return activityDetail.type == "CREATED" &&
        activityDetail.from_user_info &&
        this.mData.dataForm.ref_id
        ? activityDetail.from_user_info.full_name
        : activityDetail.from_user_name &&
          activityDetail.type == "DRAFF_SIGN_REJECTED"
        ? activityDetail.user_name
        : activityDetail.from_user_name;
    },

    fn_conditionShowRecallButton() {
      if (
        this.mData.dataForm.status == "PUBLISHED" &&
        (this.docType == "DOC_ISSUE" ||
          (this.docType == "FILTER" &&
            this.$route.query.filterType == "CBH" &&
            this.listRole &&
            this.listRole.includes("VT")) ||
          (this.docType == "FILTER" &&
            this.listRole &&
            this.listRole.includes("VT")))
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowCreateDraftButton() {
      if (
        this.mData.dataForm.status !== "SIGNED" &&
        !this.isHideButton &&
        this.isPublished &&
        (this.docType == "DOC_IN" ||
          (this.docType == "FILTER" && this.$route.query.filterType == "VBI") ||
          (this.docType == "FILTER" &&
            this.listRole &&
            this.listRole.includes("VT")))
      ) {
        return true;
      } else return;
    },

    fn_conditionShowTransferButton() {
      if (
        (this.mData.dataForm.status == "PUBLISHED" &&
          (this.docType == "DOC_IN" ||
            (this.docType == "FILTER" &&
              this.$route.query.filterType == "VBI") ||
            this.docType == "FILTER") &&
          !this.isHideButton &&
          this.isPublished) ||
        (this.mData.dataForm.status == "PUBLISHED" &&
          (this.docType == "DOC_OUT" ||
            (this.docType == "FILTER" &&
              this.$route.query.filterType == "VBO") ||
            this.docType == "FILTER") &&
          !this.isHideButton) ||
        (this.mData.dataForm.status == "RECALLED" &&
          (this.docType == "DOC_OUT" ||
            (this.docType == "FILTER" &&
              this.$route.query.filterType == "VBO") ||
            this.docType == "FILTER") &&
          !this.isHideButton) ||
        (this.mData.dataForm.publish.publisher_id ==
          this.mData.currentUser.id &&
          this.mData.dataForm.status == "RECALLED" &&
          (this.docType == "DOC_ISSUE" ||
            (this.docType == "FILTER" &&
              this.$route.query.filterType == "CBH") ||
            this.docType == "FILTER") &&
          !this.isHideButton)
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowRejectButton() {
      if (
        (this.docType == "DOC_SIGN_CONSENT" ||
          (this.docType == "FILTER" && this.$route.query.filterType == "KD") ||
          (this.docType == "FILTER" &&
            this.$route.query.statusFilter == "DOC_WAITING")) &&
        this.mData.dataForm.status == "WAITING_FOR_SIGN" &&
        !this.isSigned
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowRequestSignTempButton() {
      if (
        (this.docType == "DOC_SIGN_CONSENT" ||
          (this.docType == "FILTER" && this.$route.query.filterType == "KD") ||
          (this.docType == "FILTER" &&
            this.$route.query.statusFilter == "DOC_WAITING")) &&
        this.mData.dataForm.status == "WAITING_FOR_SIGN" &&
        !this.isSigned
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowSignButton() {
      if (
        (this.docType == "DOC_SIGN_CONSENT" ||
          (this.docType == "FILTER" && this.$route.query.filterType == "KD") ||
          (this.docType == "FILTER" &&
            this.$route.query.statusFilter == "DOC_WAITING")) &&
        this.mData.dataForm.status == "WAITING_FOR_SIGN" &&
        !this.isSigned
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowPublishButton() {
      if (
        (this.docType == "DOC_ISSUE" ||
          (this.docType == "FILTER" &&
            this.$route.query.filterType == "CBH" &&
            this.listRole &&
            this.listRole.includes("VT")) ||
          (this.docType == "FILTER" &&
            this.$route.query.statusFilter !== "DOC_SIGNED" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_SIGNED" &&
            this.listRole &&
            this.listRole.includes("VT"))) &&
        this.mData.dataForm.status == "SIGNED"
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowCancelRequestSignButton() {
      if (
        this.mData.dataForm.author_id == this.mData.currentUser.id &&
        (this.docType == "DOC_SIGN" ||
          (this.docType == "FILTER" && this.$route.query.filterType == "TK") ||
          this.docType == "FILTER") &&
        this.mData.dataForm.status == "WAITING_FOR_SIGN"
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowRecreateButton() {
      if (
        (this.docType == "DOC_SIGN" ||
          (this.docType == "FILTER" && this.$route.query.filterType == "TK") ||
          this.docType == "FILTER") &&
        this.mData.dataForm.status == "REJECT_FOR_SIGN"
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowRequestSignButton() {
      if (
        !this.isHideBtnRequestSign &&
        this.mData.dataForm.author_id == this.mData.currentUser.id &&
        (this.docType == "DOC_SIGN" ||
          (this.docType == "FILTER" && this.$route.query.filterType == "TK") ||
          (this.docType == "FILTER" &&
            this.$route.query.statusFilter !== "DOC_WAITING")) &&
        (this.mData.dataForm.status == "NEW" ||
          this.mData.dataForm.status == "WAITING_FOR_SIGN")
      ) {
        return true;
      } else return false;
    },

    fn_conditionShowTransferToOtherCompanyButton() {
      if (
        this.mData.dataForm.status == "SIGNED" &&
        !this.mData.dataForm.transfer_to_companies &&
        !this.mData.dataForm.is_transfer_back &&
        ((this.docType == "DOC_OUT" &&
          this.mData.dataForm.author_id == this.mData.currentUser.id) ||
          (this.docType == "DOC_ISSUE" &&
            this.listRole &&
            this.listRole.includes("VT")) ||
          (this.docType == "DOC_IN" &&
            this.mData.dataForm.transfer &&
            this.mData.dataForm.transfer &&
            this.mData.dataForm.transfer.person_ids &&
            !this.mData.dataForm.transfer.person_ids.includes(
              this.mData.currentUser.id
            )) ||
          (this.docType == "FILTER" &&
            (this.$route.query.statusFilter == "DOC_SIGNED" ||
              this.$route.query.filterType == "VBO")))
      ) {
        return true;
      } else return false;
    },

    async fn_changeDataDoc(data) {
      this.fn_setTypeNameDoc(data);
      this.fn_matchDocCategoryName(data);
      data.urgency_id = data.urgency_id ? data.urgency_id : "Không xác định";
      data.secret_id = data.secret_id ? data.secret_id : "Không xác định";
      await this.fn_matchBusinessName(data);
      this.fn_matchBookName(data);
      this.fn_matchCreatorName(data);
      this.fn_matchAuthorName(data);
      this.fn_setStatusDoc(data);
      if (data.signers) this.fn_matchSignerNameAndPosition(data);
      if (data.histories && data.histories.length > 0)
        this.fn_matchDataHistories(data);
      return data;
    },

    fn_getSignerStatusName(status) {
      if (status == "SIGNED") return "Đã ký";
      if (status == "REJECTED") return "Từ chối";
      if (
        this.mData.dataForm.status == "WAITING_FOR_SIGN" &&
        ["WAITING", "SIGNING", "SIGNED_FAILED"].includes(status)
      )
        return "Chờ ký";
      return "";
    },

    fn_matchSignerNameAndPosition(data) {
      data.signers.forEach((signer) => {
        this.mData.dataDefault.listAllEmployee.forEach((emp) => {
          if (emp.id == signer.user_id) {
            signer.user_name = emp.administrative_info.name.full_name;
            this.isDigitalSignature = signer.is_digital_signature
              ? true
              : false;
          }
        });
        this.mData.dataDefault.listPosition.forEach((pos) => {
          if (signer.position_id && pos.id == signer.position_id) {
            signer.position_name = pos.name;
          }
        });
        if (signer.is_add_auto) signer.position_name = "Văn thư";
      });
    },

    fn_matchDataHistories(data) {
      data.histories.forEach((o) => {
        this.mData.dataDefault.listAllEmployee.forEach((emp) => {
          if (emp.id == o.user_id) {
            o.user_name = emp.administrative_info.name.full_name;
            o.user_no = emp.employee_no;
            o.phone_number = emp.administrative_info.phone_number;
            o.avt = emp.image_id
              ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
              : emp.administrative_info.avatar_id
              ? ExtensionService.urlImg +
                emp.administrative_info.avatar_id +
                "&r=square&w=512"
              : "";
            o.job_info = emp.job_info ? emp.job_info : [];
            o.user_status = emp.status;
          }
          if (emp.id == o.from_user_id) {
            o.from_user_name = emp.administrative_info.name.full_name;
            o.from_user_no = emp.employee_no;
            o.from_user_phone_number = emp.administrative_info.phone_number;
            o.from_user_avt = emp.image_id
              ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
              : emp.administrative_info.avatar_id
              ? ExtensionService.urlImg +
                emp.administrative_info.avatar_id +
                "&r=square&w=512"
              : "";
            o.from_user_job_info = emp.job_info ? emp.job_info : [];
            o.from_user_status = emp.status;
          }
        });
        if (o.job_info && o.job_info.length > 0) {
          o.job_info = MethodService.getValidJobInfo(
            o.job_info,
            this.mData.dataDefault.listContractTypeId
          );
          if (o.job_info.length > 0) {
            this.mData.dataDefault.listPosition.forEach((pos) => {
              if (
                o.job_info[0].position_id &&
                pos.id == o.job_info[0].position_id
              ) {
                o.position_name = pos.name;
              }
            });
          }
        }
        if (o.from_user_job_info && o.from_user_job_info.length > 0) {
          o.from_user_job_info = MethodService.getValidJobInfo(
            o.from_user_job_info,
            this.mData.dataDefault.listContractTypeId
          );
          if (o.from_user_job_info.length > 0) {
            this.mData.dataDefault.listPosition.forEach((pos) => {
              if (
                o.from_user_job_info[0].position_id &&
                pos.id == o.from_user_job_info[0].position_id
              ) {
                o.from_user_position_name = pos.name;
              }
            });
          }
        }
        if (o.user_position_id) {
          const pos = this.mData.dataDefault.listPosition.find(
            (pos) => pos.id == o.user_position_id
          );
          o.user_position_name = pos && pos.name ? pos.name : "";
        }
        if (o.from_company_info && o.from_company_info.logo_id) {
          o.from_company_info.logo_company =
            ExtensionService.urlImg +
            o.from_company_info.logo_id +
            "&r=square&w=512";
        }
        if (o.other_company_info && o.other_company_info.logo_id) {
          o.other_company_info.logo_company =
            ExtensionService.urlImg +
            o.other_company_info.logo_id +
            "&r=square&w=512";
        }
      });
    },

    fn_setStatusDoc(data) {
      if (data.status === "NEW") {
        data.status_name = "Mới";
      } else if (data.status === "REJECT_FOR_SIGN") {
        data.status_name = "Đã hủy trình ký";
      } else if (
        data.status === "WAITING_FOR_SIGN" &&
        this.isShowBtnDocSignTemp &&
        (this.docType === "DOC_SIGN_TEMP" ||
          this.$route.query.statusFilter == "DOC_DRAFF_WAITING")
      ) {
        data.status_name = "Chờ ký nháy";
      } else if (
        ((data.status === "WAITING_FOR_SIGN" ||
          this.$route.query.type == "FILTER") &&
          this.isTempSigned &&
          (this.docType === "DOC_SIGN_TEMP" ||
            this.$route.query.statusFilter == "DOC_DRAFF_SIGNED")) ||
        (this.docType === "FILTER" &&
          this.$route.query.statusFilter == "DOC_DRAFF_SIGNED")
      ) {
        data.status_name = "Đã ký nháy";
      } else if (
        data.status === "REJECTED" &&
        this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED"
      ) {
        data.status_name = "Đã từ chối";
      } else if (
        data.status === "PUBLISHED" ||
        (data.status == "PUBLISHED" &&
          data.author_id == this.mData.currentUser.id)
      ) {
        data.status_name = "Đã ban hành";
      } else if (
        data.status === "WAITING_FOR_SIGN" &&
        data.author_id === this.mData.currentUser.id
      ) {
        data.status_name = "Đang chờ ký";
      } else if (
        data.status === "WAITING_FOR_SIGN" &&
        data.author_id !== this.mData.currentUser.id &&
        ((this.docType !== "DOC_SIGN_TEMP" &&
          this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED" &&
          this.$route.query.statusFilter !== "DOC_DRAFF_SIGNED") ||
          (this.$route.query.statusFilter !== "DOC_DRAFF_WAITING" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED" &&
            this.$route.query.statusFilter !== "DOC_DRAFF_SIGNED"))
      ) {
        data.status_name = "Chờ ký duyệt";
      } else if (
        (data.status === "WAITING_FOR_SIGN" ||
          this.$route.query.type == "FILTER") &&
        this.isRejectTempSigned &&
        (this.docType === "DOC_SIGN_TEMP" ||
          this.$route.query.statusFilter == "DOC_DRAFF_REJECTED")
      ) {
        data.status_name = "Đã từ chối ký nháy";
      } else if (data.status === "RECALLED") {
        data.status_name = "Đã thu hồi";
      } else if (
        data.status === "SIGNED" &&
        this.$route.query.statusFilter !== "DOC_DRAFF_SIGNED" &&
        this.$route.query.statusFilter !== "DOC_DRAFF_REJECTED"
      ) {
        data.status_name = "Đã ký duyệt";
      } else if (data.status == "TRANSFERED_OTHER_COMPANY") {
        data.status_name = "Chuyển cho công ty khác";
      } else {
        data.status_name = "Không xác định";
      }
    },

    fn_setTypeNameDoc(data) {
      data.type_name =
        data.type == "EXTERNAL_DOC_IN"
          ? "Văn bản đến nhận từ công ty ngoài"
          : data.type == "EXTERNAL_DOC_OUT"
          ? "Văn bản chuyển đi công ty ngoài"
          : data.type == "INTERNAL_DOC"
          ? "Văn bản nội bộ"
          : "-";
    },

    async fn_matchDocCategoryName(data) {
      if (data.document_category_id) {
        const documentCategoryApiRes = await DocumentCategoryApi.findById(
          data.document_category_id
        );
        if (documentCategoryApiRes.result) {
          data.document_category_name = documentCategoryApiRes.result.name
            ? documentCategoryApiRes.result.name
            : "";
        }
      } else {
        data.document_category_name = "";
      }
    },

    async fn_matchBusinessName(data) {
      if (data.business_id) {
        const documentCategoryApiRes = await DocumentBusinessApi.findById(
          data.business_id
        );
        if (documentCategoryApiRes.result) {
          data.business_name = documentCategoryApiRes.result.name;
        }
      } else {
        data.business_name = "";
      }
    },

    async fn_matchBookName(data) {
      if (data.book.book_id) {
        const documentCategoryApiRes = await BookApi.findById(
          data.book.book_id
        );
        if (documentCategoryApiRes.result) {
          data.book_name = documentCategoryApiRes.result.name;
        }
      } else {
        data.book_name = "";
      }
    },

    fn_matchCreatorName(data) {
      if (data.creator_id) {
        const o = this.mData.dataDefault.listAllEmployee.find(
          (emp) => emp.id == data.creator_id
        );
        data.creator_name = o
          ? o.administrative_info.name.full_name
          : data.creator_name
          ? data.creator_name
          : data.creator_id == this.mData.currentCompany.id
          ? this.mData.currentCompany.name.name_vi
          : "";
      }
    },

    fn_matchAuthorName(data) {
      if (data.author_id) {
        const o = this.mData.dataDefault.listAllEmployee.find(
          (emp) => emp.id == data.author_id
        );
        data.author_name = o
          ? o.administrative_info.name.full_name
          : data.author_id == this.mData.currentCompany.id
          ? this.mData.currentCompany.name.name_vi
          : "";
      }
    },

    fn_isHideDeadline(data) {
      if (
        data.status == "REJECT_FOR_SIGN" ||
        data.status == "SIGNED" ||
        data.status == "REJECTED" ||
        data.status == "PUBLISHED"
      ) {
        this.isHideDeadline = true;
        return;
      }
      if (data.signers && data.signers.length > 0) {
        const objSigner = data.signers.find(
          (signer) =>
            (signer.user_id == this.mData.currentUser.id &&
              signer.status == "NEW") ||
            (signer.user_id == this.mData.currentUser.id &&
              signer.status == "WAITING")
        );
        if (objSigner) {
          this.isHideDeadline = false;
          return;
        } else {
          data.signers.forEach((signer) => {
            if (
              signer.request_temp_signers &&
              signer.request_temp_signers.length > 0
            ) {
              const objTempSigner = signer.request_temp_signers.findIndex(
                (tempSigner) =>
                  (tempSigner.user_id == this.mData.currentUser.id &&
                    tempSigner.status == "NEW") ||
                  (tempSigner.user_id == this.mData.currentUser.id &&
                    tempSigner.status == "WAITING")
              );
              if (objTempSigner >= 0) {
                this.isHideDeadline = false;
                return;
              }
            }
          });
        }
      }
    },

    fn_checkHasSign() {
      this.isSigned = false;
      let data = this.mData.dataForm;
      if (data.signers && data.signers.length > 0) {
        const objSigner = data.signers.findIndex(
          (signer) =>
            signer.user_id == this.mData.currentUser.id &&
            signer.status == "SIGNED"
        );
        if (objSigner >= 0) {
          this.isSigned = true;
        }
      }
    },

    fn_checkDocIsSignedBySomeone() {
      this.isSignedBySomeone = false;
      let data = this.mData.dataForm;
      if (data.signers && data.signers.length > 0) {
        const objSigner = data.signers.findIndex(
          (signer) => signer.status == "SIGNED"
        );
        if (objSigner >= 0) {
          this.isSignedBySomeone = true;
        }
      }
    },

    fn_checkHasSignTemp(data) {
      this.isWaitingForSignTemp = false;
      if (data.signers && data.signers.length > 0) {
        const objSigner = data.signers.find(
          (signer) =>
            signer.user_id == this.mData.currentUser.id &&
            (signer.status == "WAITING" ||
              signer.status == "SIGNED_FAILED" ||
              signer.status == "SIGNING")
        );
        if (
          objSigner &&
          objSigner.request_temp_signers &&
          objSigner.request_temp_signers.length > 0
        ) {
          // Condition for accounts request to sign temp
          const objTempSignerReq = objSigner.request_temp_signers.findIndex(
            (tempSigner) =>
              tempSigner.status == "NEW" ||
              tempSigner.status == "SIGNING" ||
              tempSigner.status == "WAITING" ||
              tempSigner.status == "SIGNED_FAILED"
          );
          if (objTempSignerReq >= 0) {
            this.isWaitingForSignTemp = true;
          }
        }
      }
    },

    fn_checkStatusOfCurrentTempSigner() {
      if (this.mData.dataForm.status_name == "Không xác định") {
        const mainSignerName = this.fn_getPreSignerRequestTempSign(
          this.mData.dataForm
        );
        this.$notify.info({
          message: `Văn bản đã được ${
            mainSignerName ? mainSignerName : ""
          } ký duyệt, không thể thao tác.`,
          duration: 5000,
          customClass: "doc-info",
        });
        setTimeout(() => {
          this.fn_goToList();
        }, 3000);
      }
    },

    fn_getPreSignerRequestTempSign(data) {
      if (!data.signers || (data.signers && data.signers.length < 0)) return;
      let mainSignerName = null;
      data.signers.findLast((signer) => {
        if (
          signer.status == "SIGNED" &&
          signer.request_temp_signers &&
          signer.request_temp_signers.length > 0
        ) {
          const tempSigner = signer.request_temp_signers.findIndex(
            (tempSigner) => tempSigner.user_id == this.mData.currentUser.id
          );
          if (tempSigner < 0) return;
          const mainSigner = this.mData.dataDefault.listAllEmployee.find(
            (emp) => emp.id == signer.user_id
          );
          mainSignerName = mainSigner
            ? mainSigner.administrative_info.name.full_name
            : "";
          return mainSigner;
        }
      });
      return mainSignerName;
    },

    fn_checkShowBtnDocSignTemp(data) {
      this.isShowBtnDocSignTemp = false;
      if (data.status == "WAITING_FOR_SIGN") {
        if (
          (this.$route.query.type == "DOC_SIGN_TEMP" ||
            this.$route.query.statusFilter == "DOC_DRAFF_WAITING") &&
          data.signers &&
          data.signers.length > 0
        ) {
          const objSigner = data.signers.find(
            (signer) =>
              signer.status == "WAITING" ||
              signer.status == "SIGNING" ||
              signer.status == "SIGNED_FAILED"
          );
          if (
            objSigner &&
            objSigner.request_temp_signers &&
            objSigner.request_temp_signers.length > 0
          ) {
            const objTempSigner = objSigner.request_temp_signers.findIndex(
              (tempSigner) =>
                tempSigner.user_id == this.mData.currentUser.id &&
                (tempSigner.status == "NEW" ||
                  tempSigner.status == "WAITING" ||
                  tempSigner.status == "SIGNED_FAILED")
            );
            if (objTempSigner >= 0) {
              this.isShowBtnDocSignTemp = true;
            }
            // check
            this.fn_checkIsTempSign(objSigner.request_temp_signers);
            this.fn_checkIsRejectTempSign(objSigner.request_temp_signers);
          }
        }
      }
    },

    fn_checkIsTempSign(arr_request_temp_signers) {
      const objTempSigner = arr_request_temp_signers.find(
        (tempSigner) =>
          tempSigner.user_id == this.mData.currentUser.id &&
          tempSigner.status == "SIGNED"
      );
      if (objTempSigner) {
        this.isTempSigned = true;
      }
    },

    fn_checkIsRejectTempSign(arr_request_temp_signers) {
      const objTempSigner = arr_request_temp_signers.findIndex(
        (tempSigner) =>
          tempSigner.user_id == this.mData.currentUser.id &&
          tempSigner.status == "REJECTED"
      );
      if (objTempSigner >= 0) {
        this.isRejectTempSigned = true;
      }
    },

    fn_checkUnSignPerson(data) {
      if (!data.signers || (data.signers && data.signers.length < 0))
        return false;
      const unSignPerson = data.signers.find(
        (signer) => signer.status == "WAITING" || signer.status == "NEW"
      );
      if (
        !unSignPerson &&
        (data.status == "SIGNED" ||
          data.status == "REJECTED" ||
          data.status == "RECALLED")
      ) {
        return true;
      }
    },

    async fn_handle(type) {
      const documentInApiRes = await DocumentApi.findById(
        this.$router.currentRoute.params.id
      );
      let data = this.mData.dataForm;
      if (type == "transfer") {
        if (this.checkStatusRejectForSign(documentInApiRes.result)) {
          this.fn_goToList();
          return;
        }
        if (
          !this.checkStatusRejectForSign(documentInApiRes.result) &&
          this.isHideButton &&
          this.mData.dataForm.author_id == this.mData.currentUser.id
        ) {
          this.$notify.info({
            message: "Bạn không có quyền thao tác trên văn bản này.",
            duration: 3000,
            customClass: "doc-info",
          });
          return;
        }
        if (!this.isHideButton) {
          this.$router.push({
            name: "Admin-ElectronicDocument-transfer",
            params: { id: this.$route.params.id },
            query: {
              type: this.$route.query.type,
              name: data.name,
              handle: "transfer",
            },
          });
        }
      } else if (type == "transfer-for-other-company") {
        if (this.fn_checkHadTransferedToOtherCompany(documentInApiRes.result)) {
          this.$notify.info({
            message: `Văn bản này đã được chuyển sang công ty khác.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.fn_getDocById(this.$route.params.id);
          return;
        }
        this.$router.push({
          name: "Admin-ElectronicDocument-transfer-for-other-company",
          params: { id: this.$route.params.id },
          query: {
            type: this.$route.query.type,
          },
        });
      } else if (type == "recall") {
        this.dialogRecall = true;
      } else if (type == "promulgate") {
        if (this.checkStatusRejectForSign(documentInApiRes.result)) {
          this.fn_goToList();
          return;
        }
        this.$router.push({
          name: "Admin-ElectronicDocument-promulgate",
          params: { id: this.$route.params.id },
          query: {
            type: this.$route.query.type,
            name: data.name,
          },
        });
      } else if (type == "cancel-signing-process") {
        if (this.fn_checkUnSignPerson(documentInApiRes.result)) {
          this.$notify.info({
            message: `Văn bản đã được ký duyệt, bạn không có quyền thao tác trên văn bản này.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.fn_goToList();
          return;
        }
        this.dialogCancelSigningProcess = true;
      } else if (type == "recreate") {
        this.$router.push({
          name: "Admin-ElectronicDocument-create",
          query: {
            type: "DOC_OUT",
            fromDetail: this.$route.params.id,
            recreate: true,
          },
        });
      } else if (type == "reject-sign") {
        if (this.checkStatusRejectForSign(documentInApiRes.result)) {
          this.fn_goToList();
          return;
        }
        ValidService.required.message = "Vui lòng nhập lý do từ chối";
        this.dialogRejectSign = true;
      } else if (type == "request-temp") {
        if (this.checkStatusRejectForSign(documentInApiRes.result)) {
          this.fn_goToList();
          return;
        }
        this.$router.push({
          name: "Admin-ElectronicDocument-transfer",
          params: { id: this.$route.params.id },
          query: {
            type: this.$route.query.type,
            statusFilter: this.$route.query.statusFilter
              ? this.$route.query.statusFilter
              : "",
            name: data.name,
            handle: "request-sign-temp",
          },
        });
      } else if (type == "sign") {
        if (this.checkStatusRejectForSign(documentInApiRes.result)) {
          this.fn_goToList();
          return;
        }
        setTimeout(() => {
          this.$router.push({
            name: "Admin-ElectronicDocument-sign",
            params: { id: this.$route.params.id },
            query: {
              type: this.$route.query.type,
              statusFilter: this.$route.query.statusFilter
                ? this.$route.query.statusFilter
                : "",
              name: data.name,
            },
          });
        }, 800);
      } else if (type == "reject-sign-temp") {
        if (this.checkStatusRejectForSign(documentInApiRes.result)) {
          this.fn_goToList();
          return;
        }
        ValidService.required.message = "Vui lòng nhập lý do từ chối";
        this.dialogRejectSignTemp = true;
      } else if (type == "sign-temp") {
        if (this.checkStatusRejectForSign(documentInApiRes.result)) {
          this.fn_goToList();
          return;
        }
        this.$router.push({
          name: "Admin-ElectronicDocument-sign",
          params: { id: this.$route.params.id },
          query: {
            type: this.$route.query.type,
            statusFilter: this.$route.query.statusFilter
              ? this.$route.query.statusFilter
              : "",
            name: data.name,
          },
        });
      } else if (type == "edit") {
        this.$router.push({
          name: "Admin-ElectronicDocument-create",
          query: {
            type: this.$route.query.type ? this.$route.query.type : "DOC_OUT",
            fromDetail: this.$route.params.id,
            edit: true,
          },
        });
      } else if (type == "request-sign") {
        if (this.fn_checkUnSignPerson(documentInApiRes.result)) {
          this.$notify.info({
            message: `Văn bản đã được ký duyệt, bạn không có quyền thao tác trên văn bản này.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.fn_goToList();
          return;
        }
        this.$router.push({
          name: "Admin-ElectronicDocument-signRequest",
          query: {
            type: this.$route.query.type ? this.$route.query.type : "DOC_OUT",
            name: data.name,
            fromDetail: this.$route.params.id,
            recreate: true,
          },
        });
      } else if (type == "transfer-back-to-original-company") {
        const res = await DocumentApi.findById(this.$route.params.id);
        if (res.result && res.result.is_transfer_back) {
          this.$notify.info({
            message: `Văn bản này hiện đã được chuyển về công ty công ty gốc.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.dialogTransferBackToOriginalCompany = false;
          await this.fn_getDocById(this.$route.params.id);
          return;
        }
        this.dialogTransferBackToOriginalCompany = true;
      }
    },

    async fn_submitFormDialog(type) {
      let data = this.mData.dataForm;
      if (type == "recall") {
        await this.fn_recallDoc(data);
      } else if (type == "cancel-signing-process") {
        await this.fn_cancelSigningProcess(data);
      } else if (type == "reject-sign") {
        await this.fn_rejectSign(data);
      } else if (type == "reject-sign-temp") {
        await this.fn_rejectSignTemp(data);
      }
    },

    async fn_recallDoc(data) {
      try {
        await DocumentApi.RecallDocument(data.id);
        this.$notify.success({
          message: "Thu hồi văn bản thành công.",
          duration: 3000,
          customClass: "doc-success",
        });
        this.dialogRecall = false;
        await this.fn_getDocById(this.$router.currentRoute.params.id);
      } catch (error) {
        if (error.code == 404 || error.code == 401 || error.code == 500) {
          this.$notify.warning({
            message: `${error.detail ? error.detail : "Có lỗi xảy ra."}`,
            duration: 3000,
            customClass: "doc-warning",
          });
          return;
        }
        this.$notify.warning({
          message: "Có lỗi xảy ra.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    async fn_cancelSigningProcess(data) {
      try {
        const documentInApiRes = await DocumentApi.findById(
          this.$router.currentRoute.params.id
        );
        if (this.fn_checkUnSignPerson(documentInApiRes.result)) {
          this.$notify.info({
            message: `Văn bản đã được ký duyệt, bạn không có quyền thao tác trên văn bản này.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.fn_goToList();
          return;
        }
        const rejectSignRequestRes = await DocumentApi.RejectSignRequest(
          data.id
        );
        if (rejectSignRequestRes.result) {
          this.$notify.success({
            message: "Hủy trình ký văn bản thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          await this.fn_getDocById(this.$router.currentRoute.params.id);
          this.dialogCancelSigningProcess = false;
        }
      } catch (error) {
        if (error.code == 404 || error.code == 401 || error.code == 500) {
          this.$notify.warning({
            message: `${error.detail ? error.detail : "Có lỗi xảy ra."}`,
            duration: 3000,
            customClass: "doc-warning",
          });
          this.dialogCancelSigningProcess = false;
          return;
        }
        this.$notify.warning({
          message: "Có lỗi xảy ra.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    async fn_rejectSign(data) {
      this.$refs["formRejectSign"].validate(async (valid) => {
        if (!valid) return;
        try {
          const documentInApiRes = await DocumentApi.SignForReject({
            id: data.id,
            note: this.mData.dataFormRejectSign.rejectReason
              ? this.mData.dataFormRejectSign.rejectReason.trim()
              : "",
          });
          if (documentInApiRes.result) {
            await this.fn_getDocById(this.$router.currentRoute.params.id);
            this.$notify.success({
              message: "Từ chối ký duyệt thành công.",
              duration: 3000,
              customClass: "doc-success",
            });
            this.dialogRejectSign = false;
          }
        } catch (error) {
          if (error.code == 404 || error.code == 401 || error.code == 500) {
            this.$notify.warning({
              message: `${error.detail ? error.detail : "Có lỗi xảy ra."}`,
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          }
          this.$notify.warning({
            message: "Có lỗi xảy ra.",
            duration: 3000,
            customClass: "doc-warning",
          });
        }
      });
    },

    async fn_rejectSignTemp(data) {
      this.$refs["formRejectSignTemp"].validate(async (valid) => {
        if (!valid) return;
        try {
          const documentInApiRes = await DocumentApi.findById(
            this.$router.currentRoute.params.id
          );
          if (this.checkStatusRejectForSign(documentInApiRes.result)) {
            this.fn_goToList();
            return;
          }
          const objWaitingSigner = data.signers.find(
            (signer) => signer.status == "WAITING"
          );
          if (!objWaitingSigner) return;
          const res = await DocumentApi.SignForRejectDraff({
            id: data.id,
            signer_id: objWaitingSigner.user_id,
            note: this.mData.dataFormRejectSign.rejectReason
              ? this.mData.dataFormRejectSign.rejectReason.trim()
              : "",
          });
          if (res.result) {
            await this.fn_getDocById(this.$router.currentRoute.params.id);
            this.$notify.success({
              message: "Từ chối ký nháy thành công.",
              duration: 3000,
              customClass: "doc-success",
            });
            this.dialogRejectSignTemp = false;
          }
        } catch (error) {
          if (error.code == 404 || error.code == 401 || error.code == 500) {
            this.$notify.warning({
              message: `${error.detail ? error.detail : "Có lỗi xảy ra."}`,
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          }
          this.$notify.warning({
            message: "Có lỗi xảy ra.",
            duration: 3000,
            customClass: "doc-warning",
          });
        }
      });
    },

    fn_closeDialogRejectSign() {
      this.$refs["formRejectSign"].resetFields();
      this.dialogRejectSign = false;
    },

    fn_closeDialogRejectSignTemp() {
      this.$refs["formRejectSignTemp"].resetFields();
      this.dialogRejectSignTemp = false;
    },

    fn_closeDialogTransferBackToOriginalCompany() {
      this.dialogTransferBackToOriginalCompany = false;
    },

    async getDepartment(id) {
      this.listDerpartment = [];
      const departmentApiReq = await DepartmentApi.findById(id);
      this.listDepartment.push(departmentApiReq.result);
    },

    fn_checkRenderDocToPdf() {
      this.isHideBtnRequestSign = false;
      if (
        (this.mData.dataForm.doc_file.type == "doc" ||
          this.mData.dataForm.doc_file.type == "docx") &&
        (this.$route.query.from == "create" ||
          this.$route.query.from == "edit" ||
          this.$route.query.from == "recreate")
      ) {
        this.isHideBtnRequestSign = true;
        this.$notify.warning({
          message:
            "Quá trình chuyển đổi từ doc/docx sang PDF thất bại. Vui lòng upload lại file hoặc tạo lại văn bản mới.",
          duration: 5000,
          customClass: "doc-warning",
        });
      }
    },

    fn_checkPublished(data) {
      if (
        data.status === "PUBLISHED" &&
        data.publish &&
        data.publish.publisher_to_ids &&
        data.publish.publisher_to_ids.length > 0
      ) {
        const flag = data.publish.publisher_to_ids.includes(
          this.mData.currentUser.id
        );
        this.isPublished = flag ? true : false;
      }
    },
  },

  async created() {
    this.docType = this.$route.query.type;
    this.fn_eventBus(this.checkTab(this.docType), "detail");
    await this.fn_getListConTractType();
    this.fn_getListPosition();
    await this.fn_getListAllEmployee();
    await this.fn_getDocById(this.$router.currentRoute.params.id);
    await this.fn_checkRenderDocToPdf();
    if (this.$route.query.type !== "FILTER") {
      await this.fn_checkStatusOfCurrentTempSigner();
    }
  },

  destroyed() {
    ValidService.required.message = "Vui lòng nhập giá trị";
  },
};
</script>

<style lang="scss" scoped>
.button__group {
  display: flex;
  justify-content: space-between;
}
.block-history-note {
  border: 1px solid var(--orange);
  border-radius: 5px;
  background-color: #ffeadc;
  padding: 8px 16px;
}
.signer-status {
  display: inline-block;
  margin-left: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--white);
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;

  &--waiting,
  &--signing,
  &--signed_failed {
    background-color: var(--orange);
  }

  &--signed {
    background-color: var(--turquoise);
  }

  &--rejected {
    background-color: var(--red);
  }
}
svg path,
svg rect {
  fill: rgb(247, 248, 252) !important;
}
.text-overflow-1 {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  word-break: break-word;
  -webkit-box-orient: vertical;
}
.text-overflow-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  word-break: break-word;
  -webkit-box-orient: vertical;
}
.text-overflow-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  word-break: break-word;
  -webkit-box-orient: vertical;
}
.animated {
  position: relative;
}
::v-deep .drawer-container {
  .drawer {
    position: absolute;
    top: 0;
    border-left: 0;
    background-color: rgba(41, 45, 50, 0.97);
    width: 25%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 3px 0px 2px 0px rgb(0 0 0 / 7%);
    z-index: 99;
    .drawer__back-icon {
      height: 56px;
      background-color: #292d32;
      border-bottom: 1px solid;
    }
  }
  .drawer-collapse {
    position: absolute;
    top: 0;
    left: 0;
    background: #292d32;
    width: 3%;
    height: 100%;
    overflow: auto;
    .drawer__header {
      flex-direction: column;
      background: #292d32;
      .drawer__header-title {
        background: #292d32;
        writing-mode: vertical-rl;
      }
    }
  }
  .drawer__header {
    background: #292d32;
    padding: 15px 10px;
    justify-content: flex-end;
    .drawer__header-title {
      color: var(--white);
    }
  }
  .drawer__box {
    .drawer__box-title {
      padding: 10px 10px;
      background: #ababab;
      color: #292d32;
    }
    .drawer__box-content {
      padding: 10px;
    }
    .el-collapse {
      border: none;
    }
    .el-collapse-item {
      .el-collapse-item__header {
        text-transform: none;
        box-shadow: none;
        border-radius: 0;
        background-color: transparent;
        color: #fff;
        flex-direction: row-reverse;
        justify-content: flex-end;
        i {
          margin: 0 8px 0;
          width: 30px;
        }
      }
      .el-collapse-item__wrap {
        border-radius: 0;
        background-color: transparent;
        .el-collapse-item__content {
          padding: 5px 0;
          color: #7e7e7e;
          background-color: transparent;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
.preview-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: calc(100vh - 100px);
  background-color: #d0d5d9;
  .preview__file-container {
    position: absolute;
    top: 0;
    height: 100%;
    overflow: auto;
    background-color: #d0d5d9;
  }
}
::v-deep .timeline {
  padding: 60px 20px 20px;
  border: 1px solid;
  overflow: auto;
  height: 100%;
  .el-timeline {
    .el-timeline-item {
      &:first-child::after {
        content: "";
        position: absolute;
        top: -20px;
        left: 4px;
        width: 2px;
        height: 20px;
        background-color: #000;
      }
      &:first-child::before {
        content: "";
        position: absolute;
        top: -30px;
        left: 0px;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 10px solid #000; /* Tam giác phía dưới được đổ màu */
      }
      .el-timeline-item__tail {
        border-left: 2px solid #000;
      }
      .el-timeline-item__node--normal {
        left: 2px;
        width: 6px;
        height: 6px;
        background-color: #000;
      }
    }
  }
}
::v-deep .empty__tab-text {
  color: #b3b3b3;
}
::v-deep .el-textarea__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
.dialog__text-warning {
  max-width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0px auto;
  padding-bottom: 15px;
  line-height: inherit;
}
.urgency {
  width: fit-content;
  padding: 5px 10px;
  background-color: #ff5621;
  border-radius: 4px;
  color: white;
  text-align: center;
}
.secret {
  width: fit-content;
  padding: 5px 10px;
  background-color: #f12727;
  border-radius: 4px;
  color: white;
  text-align: center;
}
.block-turquoise {
  width: fit-content;
  padding: 5px 10px;
  background-color: var(--turquoise);
  border-radius: 4px;
  color: white;
  text-align: center;
}
.block-yellow {
  width: fit-content;
  padding: 5px 10px;
  background-color: #ffa800;
  border-radius: 4px;
  color: white;
  text-align: center;
}
.block-red {
  width: fit-content;
  padding: 5px 10px;
  background-color: var(--red);
  border-radius: 4px;
  color: white;
  text-align: center;
}
::v-deep .el-form {
  border: 1px solid #7e7e7e;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.right-side {
  .preview-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 150px);
    box-shadow: 7px 7px 21px -7px rgb(0, 0, 0, 30%);
  }
  .preview__file-container {
    flex: 1;
    background: #bebebe;
    width: 100%;
    overflow: auto;
    position: relative;
  }
  .preview__file-footer {
    flex-shrink: 0;
    background-color: rgba(41, 45, 50, 0.7);
    width: 100%;
    padding: 10px;
    transition: 0.3s ease;
    cursor: pointer;
    p {
      margin-bottom: 0;
    }
    &:hover {
      background-color: rgba(41, 45, 50, 0.95);
    }
  }
}
::v-deep .el-divider--horizontal {
  margin: 10px 0;
}
.empty-content {
  height: 500px;
  padding: 200px 0;
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  padding: 5px;
  height: calc(100vh - 202px);
  .el-tab-pane {
    height: 100%;
  }
}
::v-deep .el-tabs__nav {
  width: 100%;

  &:not(.is-active)::after {
    content: "";
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 2px;
    background: #d0d5d9;
  }
  .el-tabs__item {
    width: 50%;
    border-radius: 0;
    background-color: #e9e9e9;

    span {
      color: black;
    }
  }
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;
  }
  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;
    border-right: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
.icon-prefix,
.icon-suffix {
  font-size: 21px;
}
.el-icon-d-arrow-left,
.el-icon-d-arrow-right {
  font-size: 16px;
  background: #fff;
  border-radius: 1px;
}
::v-deep .icon {
  cursor: pointer;
}
::v-deep .isax-trash {
  color: var(--red);
}
::v-deep .isax-eye {
  color: var(--orange);
}
::v-deep .el-upload-dragger {
  height: 36px;
}
::v-deep .el-upload {
  display: none;
}
::v-deep .el-upload__tip {
  position: absolute;
  top: 0;
  left: 380px;
  font-style: italic;
  color: #606266;
  margin-top: 0;
}

::v-deep .el-dialog__body {
  padding: 0px !important;
}
::v-deep .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}

::v-deep .document-more-information {
  .el-dialog {
    margin-bottom: 0;
    .el-dialog__header {
      background-color: #4d8db3 !important;
    }
    .el-dialog__body {
      padding: 20px !important;
      height: calc(100vh - 125px);
      .el-form {
        border: none;
        padding-right: 10px;
        .el-input-number .el-input__inner {
          text-align: left;
        }
        .el-textarea {
          .el-textarea__inner {
            border-radius: 0;
            box-shadow: none !important;
            border-radius: 5px !important;
            padding-bottom: 15px;
          }
          .el-input__count {
            background: transparent;
            right: 4px;
            bottom: -6px;
          }
        }
      }
    }
  }
}
p {
  font-size: 15px;
  margin-bottom: 10px;
}
.icon-update-booknumber {
  border-radius: 50%;
  padding: 5px;
  transition: 0.3s ease;
  &:hover {
    background-color: rgba(190, 190, 190, 0.4);
  }
  &:active {
    background-color: rgba(190, 190, 190, 0.6);
  }
}
.fa-check,
.fa-times,
.el-icon-close {
  font-size: 24px;
  width: 35px;
  height: 35px;
  text-align: center;
  border-radius: 50%;
  padding: 5px;
  transition: 0.3s ease;
  &:hover {
    background-color: rgba(190, 190, 190, 0.4);
  }
  &:active {
    background-color: rgba(190, 190, 190, 0.6);
  }
}
@media (max-width: 1180px) {
  ::v-deep .el-dialog {
    width: 55% !important;
  }
}
</style>
